export type TranslationKey =
  | 'success' | 'error' | 'cancel' | 'save' | 'delete' | 'edit' | 'add' | 'back'
  | 'onboarding' | 'active' | 'extension' | 'offboarding' | 'complete'
  | 'addCustomField' | 'editField' | 'fieldName' | 'note' | 'fieldNotePlaceholder' | 'noteSupportsHtml' | 'displayNoteInGrid' | 'displayNoteHelpText' | 'inputType' | 'colorCodeInput'
  | 'allowMultipleSelections' | 'dropdownOptions' | 'visibleOnStages' | 'backToColumns'
  | 'fieldCreated' | 'fieldUpdated' | 'fieldDeleted' | 'noCustomFieldsAvailable'
  | 'selectOptions' | 'editColumns'
  | 'retainColumnData' | 'retainColumnDataDescription'
  | 'clear' | 'clearAll' | 'showMore' | 'typeToFilter' | 'enterValue' | 'startDate' | 'endDateOptional' | 'noRecordsFound' | 'loading' | 'searchCharLimit'
  | 'filter' | 'clearFilters' | 'clearAllFilters' | 'resetToView' | 'resetToDefault' | 'clearSelection' | 'itemsSelected' | 'selectAction'
  | 'activeFilters' | 'globalFilters' | 'stageFiltersHeading'
  | 'selectOption' | 'selectDate' | 'clickToEdit' | 'today'
  | 'copy' | 'copied' | 'copyFailed' | 'sendEmail' | 'sendEmailTo' | 'invalidEmailFormat'
  | 'apply' | 'customColumn' | 'search'
  | 'january' | 'february' | 'march' | 'april' | 'may' | 'june' | 'july' | 'august' | 'september' | 'october' | 'november' | 'december'
  | 'sun' | 'mon' | 'tue' | 'wed' | 'thu' | 'fri' | 'sat'
  | 'previous' | 'next' | 'showingRecords' | 'rowsPer'
  | 'editWorkItems' | 'addNewField' | 'close' | 'ok' | 'option'
  | 'moveTo' | 'bulkAction' | 'messages' | 'markAsRead' | 'markAsUnread'
  | 'message' | 'mute' | 'unmute'
  | 'messageNotifications' | 'on' | 'off'
  | 'messageNotificationsShowLabel' | 'messageNotificationsShowDescription' | 'messageNotificationsWarningTitle' | 'messageNotificationsWarningBody' | 'messageNotificationsSaveError' | 'messageNotificationsSaveErrorRetry'
  | 'areYouSure' | 'moveToSuccess' | 'moveToFailed' | 'moveToPartial' | 'moveToError' | 'processing' | 'partialSuccess'
  | 'itemsUpdatedSuccess' | 'failedToUpdateItems' | 'actionFailed' | 'actionSuccess' | 'reprocessTriggered'
  | 'processingActionSingle' | 'processingActionMultiple'
  | 'noActionsAvailable' | 'confirmDeleteOption' | 'noSuggestions'
  | 'myViews' | 'sharedWithMe' | 'allCompany' | 'saveViewAs' | 'saveThisView' | 'title' | 'myCustomView' | 'description'
  | 'deleteViewConfirmation' | 'deleteViewWarning' | 'share' | 'saveChanges' | 'changesSuccess' | 'saveAsNew' | 'deleteView'
  | 'saveView' | 'visibility' | 'private' | 'public' | 'clientFacing'
  | 'hiddenColumns' | 'visibleColumns' | 'editColumnsSubtitle' | 'nameYourCustomView'
  | 'moveToTop' | 'moveToBottom'
  | 'manageViews' | 'searchViews' | 'showView' | 'view' | 'editView' | 'noMyViews' | 'noPublicViews' | 'createView' | 'viewNotFound' | 'hideView'
  | 'viewSavedSuccessfully' | 'columnConfigurationUpdatedSuccessfully' | 'failedToSaveView'
  | 'unsavedChangesTitle' | 'unsavedChanges' | 'unsavedChangesWarning' | 'switchView'
  | 'dismissError' | 'refreshView' | 'refreshViewTitle' | 'refreshViewMessage'
  | 'inputTypeText' | 'inputTypeYesNo' | 'inputTypeDropdown' | 'inputTypeDate' | 'inputTypeNumber' | 'inputTypeEmail' | 'inputTypeChecklist'
  | 'blank'
  | 'automations'
  | 'showChangesInProgress'
  | 'searchChanges' | 'loadingHistory' | 'noChangesFound' | 'changesFound' | 'changeFound' | 'new' | 'by' | 'unknownUser' | 'unknownDate' | 'changeReason' | 'changes' | 'loadMore' | 'viewHistory' | 'viewMessages'
  | 'pinTooltip' | 'unpinTooltip'
  | 'seconds' | 'confirmUpdate' | 'confirm' | 'yes' | 'no' | 'someValuesEmpty'
  | 'viewSelector'
  | 'all' | 'lastWeek' | 'lastMonth' | '90days' | 'lastYear' | 'custom' | 'stage' | 'true' | 'false'
  | 'changeHistory' | 'automationEmails' | 'historyOf' | 'candidate' | 'allStages' | 'allUsers'
  | 'adjustSearchFilters' | 'showing' | 'change' | 'additionalInfo' | 'clickToExpand' | 'clickToCollapse'
  | 'endDate' | 'of' | 'sentTo' | 'sentFrom' | 'sentAt' | 'subject' | 'noEmailsFound' | 'loadingEmails' | 'searchEmailSubject' | 'automationEmailHistoryOf'
  | 'refresh' | 'refreshAutomationEmails' | 'refreshChangeHistory'
  | 'stages' | 'selectRecipient' | 'to' | 'from' | 'showLess'
  | 'min' | 'max' | 'auto' | 'selectAll'
  | 'searchWorkers' | 'searchWorker' | 'workerName' | 'clientName' | 'workOrderId' | 'searchHelperText'
  | 'whoCanViewColumn' | 'noUsersSelected' | 'updateColumnAccess'
  | 'confirmMakePrivate' | 'confirmMakePrivateMessage' | 'confirmMakePublic' | 'confirmMakePublicMessage'
  | 'privateColumn' | 'default' | 'searchUsersPlaceholder' | 'noUsersFound' | 'searchingUsers' | 'typeToSearchUsers' | 'typeAtLeastTwoChars' | 'searchAllColumns'
  | 'jumpToColumn' | 'jumpToColumnPlaceholder' | 'noMatchingColumn' | 'addToView'
  | 'privateColumnWarningTitle' | 'privateColumnWarningMessage' | 'saveAnyway'
  | 'worker' | 'workOrderIdLabel' | 'itemsCompleted' | 'addNewItem' | 'unsavedChecklistChanges' | 'unsavedChecklistMessage'
  | 'confirmAction' | 'actionConfirmMessage' | 'notes' | 'optional' | 'addNotesPlaceholder' | 'selectedItems' | 'noActionsHint'
  | 'added' | 'removed' | 'completed' | 'deleted' | 'restored'
  | 'duplicateItemError' | 'duplicateItemsPreventSave'
  | 'fixedPosition' | 'dateFormatting' | 'shortDateFormat' | 'dateTimeFormat' | 'manageColumnsDescription'
  | 'extendWorkOrder' | 'extendWorkOrderQuestion' | 'newPlacementId' | 'enterPlacementId' | 'invalidPlacementId' | 'failedValidateAtsPlacement'
  | 'extensionCreatedSuccess' | 'extensionCreatedSuccessFor' | 'failedCreateExtension' | 'errorExtendingWorkOrder' | 'processingExtension' | 'extensionChangesWillAppearSoon' | 'viewExtensionInFbo'
  | 'continueWithoutPlacementId' | 'validateAndExtend' | 'submit' | 'client' | 'worker' | 'lineOfBusiness' | 'dates'
  | 'continueWithWarning' | 'areYouSureExtend' | 'extensionWorkOrderCreationFailed' | 'createExtensionManually'
  | 'clientMismatch' | 'workerMismatch'
  | 'extensionAlreadyScheduledDescription' | 'extendExistingExtensionQuestion' | 'extendExistingExtension' | 'openWorkOrder'
  | 'clientVisibleColumn'
  // View Manager
  | 'vmTitle' | 'vmStepColumns' | 'vmStepFields' | 'vmStepFilters'
  | 'vmDiscardTitle' | 'vmDiscardDescription' | 'vmKeepEditing'
  | 'vmCategoryPrivate' | 'vmCategoryClient' | 'vmCategoryDefault'
  | 'vmNoViews' | 'vmSelectViewFirst' | 'vmApplyToStages'
  | 'vmBackToViews' | 'vmViewProperties' | 'vmEditColumns' | 'vmFilterType'
  | 'vmColumnPreview' | 'vmClientOrgs' | 'vmNoEditPermission'
  | 'vmGlobalFilters' | 'vmStageFilters' | 'vmSearchFields' | 'vmNoMatchingFields' | 'vmNoStageFilters' | 'vmAddFilter' | 'vmSortedBy' | 'vmNoSort' | 'vmSelectSortField' | 'vmAscending' | 'vmDescending'
  | 'vmStageColumnsHelp' | 'vmCopyLayoutTo' | 'vmNone' | 'vmNoVisibleColumns'
  // Client Requests Tab
  | 'requests' | 'clientRequests' | 'showCompleted' | 'tasks'
  // Grid column labels
  | 'status' | 'requestTypeLabel' | 'requestedBy' | 'dateRequested'
  | 'clientOrg' | 'workerOrg' | 'lineOfBusiness' | 'profileType'
  | 'billRate' | 'payRate'
  // Facet label
  | 'requestTypeFacet'
  // Status badge keys
  | 'statusDraft' | 'statusInitiated' | 'statusVerifyingWorker' | 'statusReviewWorkerInfo' | 'statusWorkerInfoReviewed' | 'statusNew' | 'statusPreVerificationRequested' | 'statusPreVerificationReview' | 'statusPreVerificationComplete' | 'statusAccepted' | 'statusCancelled' | 'statusRejected' | 'statusOnHold' | 'statusInProgress' | 'statusAtsAccepted' | 'statusAtsCancelled'
  // Request type keys
  | 'requestTypeOnboarding' | 'requestTypeGeneral' | 'requestTypeExtension'
  | 'requestTypeRedeployment' | 'requestTypeTermination' | 'requestTypeOther'
  | 'requestTypePreOnboarding'
  // Detail panel keys
  | 'requestDetailsHeader' | 'requestInfo' | 'consultantInfo'
  | 'terminationDetailsSection' | 'attachmentsLabel'
  | 'requestDetailsField' | 'workerFullName' | 'assignedTo'
  | 'billRateUnit' | 'rateLabel' | 'rateUnitLabel' | 'terminationDetailsField'
  | 'jobTitleLabel' | 'hiringManager' | 'hiringManagerEmail'
  // Grid UI strings
  | 'noOptionsAvailable' | 'noRecords'
  // Client Request Action labels
  | 'actionStartPreVerification' | 'actionProceedToOnboarding' | 'actionViewPreverification'
  | 'actionAcknowledge' | 'actionCancelRequest' | 'actionOnHold'
  // Client Request Action Modal
  | 'notesRequired' | 'unknownWorker'
  // New Onboarding Request button
  | 'newOnboardingRequest'
  // Client Request Modal
  | 'requestExtensionTitle' | 'requestTerminationTitle' | 'requestRedeploymentTitle' | 'requestOtherChangesTitle'
  | 'requestSubmitted' | 'requestSubmittedSuccess' | 'submissionFailed' | 'submissionError'
  | 'hiringManagerNameLabel' | 'includeRateUpdate'
  | 'submitRequest' | 'submitting'
  | 'enterJobTitlePlaceholder' | 'fullNamePlaceholder' | 'emailPlaceholder'
  | 'ratePlaceholder' | 'rateUnitPlaceholder'
  | 'currentEndDate' | 'currentRate'
  | 'rateUnitHour' | 'rateUnitDay' | 'rateUnitFixed' | 'rateUnitWords' | 'rateUnitMonthly' | 'rateUnitShift'
  | 'terminationDetailsPlaceholder' | 'requestDetailsPlaceholder' | 'manageCustomFields'
  | 'deleteCustomFieldConfirmTitle' | 'deleteCustomFieldConfirmBody' | 'deleteFailed'
  | 'suggestions' | 'clearSearch' | 'actions'
  | 'onboardingSuccess' | 'onboardingFailed'
  | 'warning' | 'preVerificationCloseFailed'
  | 'vmsAcceptFailedAfterOnboarding' | 'clientRequestCloseFailedAfterOnboarding' | 'clientRequestLinkFailedAfterOnboarding'
  | 'request'
  // Request Progress Panel — actor type labels
  | 'actorTypeWorker' | 'actorTypeClientServices' | 'actorTypeAccountManager'
  | 'actorTypeExecutive' | 'actorTypeRecruiter'
  | 'actorTypeSubvendorOrg' | 'actorTypeSubvendorWorker'
  | 'actorTypeReadOnly'
  // Request Progress Panel — UI strings
  | 'rppTitle' | 'rppLoadingRequests' | 'rppNoRequests' | 'rppLoadError'
  | 'rppNoAssignees' | 'rppAssigneesCount' | 'rppDragHoverHint' | 'rppActorDetails' | 'rppCompletedOn'
  | 'rppTitle' | 'rppLoadingRequests' | 'rppNoRequests'
  | 'rppNoAssignees' | 'rppAssigneesCount' | 'rppDragHoverHint'
  // Related Requests Panel — UI strings
  | 'rrpTitle' | 'rrpLoadingRequests' | 'rrpNoRequests' | 'rrpLoadError'
  | 'rrpDetailLoadError' | 'rrpLoadingDetail' | 'rrpCommentsHeader' | 'rrpNoComments'
  | 'rrpRequestDateLabel' | 'rrpActionedBy' | 'rrpOpenOnboardingRequest'
  | 'rrpAnticipatedStartDate' | 'rrpExpandPanel' | 'rrpCollapsePanel'
  // ATS Placements
  | 'atsCreateSuccess' | 'atsCreateNotFound' | 'atsCreateError'
  | 'atsStartPreVerificationFailed' | 'atsResyncFailed' | 'atsResyncSuccess' | 'atsCreateInFboFailed'
  | 'atsAcceptFailedAfterOnboarding' | 'atsLoadPlacementsFailed' | 'atsAssignUserFailed' | 'atsNoPlacementsPendingReview'
  | 'atsCreateModalTitle' | 'atsPlacementIdLabel' | 'atsPlacementIdPlaceholder'
  | 'atsCreateButton' | 'atsCreatingButton'
  | 'atsCreateDuplicate' | 'atsCreateDuplicateWorker' | 'atsCreateDuplicateClient'
  | 'atsCreateDuplicateQuestion' | 'atsCreateProceed'
  | 'atsCancelModalTitle'
  | 'atsSourceName' | 'atsPlacementNoun' | 'atsHoldActionName'
  // ATS Sync Settings
  | 'atsSyncCreateNewAts' | 'atsSyncInclusionSettingsLabel' | 'atsRefreshLabel'
  | 'atsSyncSearchLabel' | 'atsSyncSearchPlaceholder' | 'atsSyncFilters'
  | 'atsSyncStatus' | 'atsSyncStatusAll' | 'atsSyncStatusEnabled' | 'atsSyncStatusDisabled' | 'atsSyncWarningsOnly' | 'atsSyncUnmappedOnly'
  | 'atsSyncCountry' | 'atsSyncAny' | 'atsSyncProvinceState' | 'atsSyncSelectCountryFirst' | 'atsSyncCity'
  | 'atsSyncSearchCountry' | 'atsSyncSearchSubdivision' | 'atsSyncNoResults'
  | 'atsSyncNoClientsMatch' | 'atsSyncModalTitle' | 'atsSyncModalSubtitle' | 'atsSyncClientsEnabled'
  | 'atsSyncClientsShown' | 'atsSyncClientsTotal' | 'atsSyncUnsavedChange' | 'atsSyncUnsavedChanges'
  | 'atsSyncApplyToAll' | 'atsSyncSaving'
  | 'atsSyncUnmappedClientsLabel' | 'atsSyncUnmappedClientsTooltip' | 'atsSyncUnmappedClientsSubtitle'
  | 'atsSyncNoMappingTooltip' | 'atsSyncDuplicateSingleTooltip' | 'atsSyncDuplicateMultipleTooltip'
  | 'atsSyncApplyToAllTitle' | 'atsSyncApplyToAllBodySingular' | 'atsSyncApplyToAllBodyPlural'
  | 'atsSyncAllClients' | 'atsSyncAllLinesOfBusiness' | 'atsSyncApplyToCount'
  // Export Modal
  | 'exportToExcel' | 'exportScope' | 'current' | 'rows'
  | 'exportColumnsForStage' | 'exportExcludeInternal' | 'exportShowVisibleOnly' | 'exportShowAllColumns'
  | 'exportNoColumns' | 'exportNotClientFacing' | 'exportPrivateColumn'
  | 'exportWarnNotClientFacingCount' | 'exportWarnNotClientFacingBody'
  | 'exportWarnPrivateCount' | 'exportWarnPrivateBody' | 'exportTooLarge'
  | 'exportFilename' | 'exportFilenameHint' | 'exporting' | 'exportRowsButton'
  | 'exportUnexpectedError' | 'exportServerError'
  // VMS Integration Settings
  | 'vmsSkipPublicDomainFilterLabel' | 'vmsSkipPublicDomainFilterNote'
  | 'vmsSettingsTitle' | 'vmsTenant' | 'vmsAllTypes' | 'vmsActiveOnly'
  | 'vmsSearchPlaceholder' | 'vmsNoSettingsMatch' | 'vmsSelectSetting'
  | 'vmsInactive' | 'vmsCopyEmail' | 'vmsEmailsReceived' | 'vmsLast'
  | 'vmsFboClient' | 'vmsClientReadOnly' | 'vmsDisplayName' | 'vmsNotesOptional' | 'vmsNotesPlaceholder'
  | 'vmsDiscard'
  | 'vmsDeleteSetting' | 'vmsDeleteConfirm' | 'vmsDeleteEmailWarning' | 'vmsDeleting'
  | 'vmsNewTenantSetting' | 'vmsNewClientSetting' | 'vmsTenantDescription' | 'vmsClientDescription'
  | 'vmsSearchClient' | 'vmsChangeClient'
  | 'vmsTenantNameExample' | 'vmsClientNameExample'
  | 'vmsLlmConfig' | 'vmsLlmConfigDescription' | 'vmsDefaultLlmConfig' | 'vmsModel' | 'vmsMaxTokens'
  | 'vmsCustomPrompt' | 'vmsCustomPromptPlaceholder' | 'vmsPromptSafetyNote'
  | 'vmsEmailDomain' | 'vmsEmailDomainNote'
  | 'vmsDiscardConfirm' | 'vmsGoBack' | 'vmsDiscardContinue'
  | 'vmsTypeLabel' | 'vmsTypeNone' | 'vmsTypeNote'
  | 'vmsDefaultAssignees' | 'vmsSearchUsers' | 'vmsPrimaryAssignee' | 'vmsPrimaryAssigneeNote'
  | 'vmsLoadedHint' | 'vmsLoadingMore'
  | 'vmsMainInfo' | 'vmsVersionTooltip'
  | 'vmsHistorySection' | 'vmsNoAuditEntries'
  | 'vmsCopySuccess' | 'vmsCopyInactiveWarning' | 'vmsRowCopyEmail'
  // Added: previously-missing keys
  | 'allowDataExport' | 'alsoSaveChangesOn' | 'alsoSaveChangesOnHelp' | 'applyChanges' | 'atsSyncSettings'
  | 'bulkEditDescription' | 'bulkUpdateError' | 'bulkUpdateErrorDesc' | 'bulkUpdateFailed' | 'bulkUpdatePartial'
  | 'bulkUpdateSuccess' | 'done' | 'export' | 'field' | 'hours'
  | 'minutes' | 'noFieldsSelected' | 'originalEmail' | 'pleaseSelectAtLeastOneField' | 'removeField'
  | 'selectEndDate' | 'selectField' | 'selectFieldFirst' | 'selectStartDate' | 'time'
  | 'updatesView' | 'value' | 'viewAllowDataExportEnabled' | 'vmAllowDataExportHelp'
  | 'vmExportDisabled' | 'vmExportEnabled' | 'vmRevert'
  | 'bannerTitleInfo' | 'bannerTitleWarning' | 'bannerTitleError' | 'maintenanceInProgress' | 'scheduledMaintenanceUpcoming' | 'upcomingMaintenanceBody' | 'scheduledFor' | 'fullAccessExpectedBy' | 'collapseMaintenanceMessage' | 'expandMaintenanceMessage' | 'inEffectSince'
  // Messages inbox filters
  | 'inboxSearchPlaceholder' | 'inboxFilters' | 'inboxFilterDate' | 'inboxFilterFrom' | 'inboxFilterTo' | 'inboxFilterWorkOrderStages' | 'inboxFilterRequests' | 'inboxFilterSender' | 'inboxFilterAny' | 'inboxFilterSelectedCount' | 'inboxNoMatches'

export const translations = {
  en: {
    // Common
    success: 'Success',
    error: 'Error',
    cancel: 'Cancel',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    back: 'Back',
    editWorkItems: 'Edit work items',
    addNewField: 'Add new field',
    close: 'Close',
    ok: 'OK',
    option: 'Option',
    filter: 'Filter',
    clearFilters: 'Clear filters',
    activeFilters: 'Active filters',
    globalFilters: 'Global Filters',
    stageFiltersHeading: '{stage} stage filters',
    clearAllFilters: 'Clear All Filters',
    bannerTitleInfo: 'Notice',
    bannerTitleWarning: 'Warning',
    bannerTitleError: 'Important',
    maintenanceInProgress: 'Scheduled maintenance in progress',
    scheduledMaintenanceUpcoming: 'Scheduled maintenance upcoming',
    upcomingMaintenanceBody: 'Scheduled maintenance is planned. Some actions may be temporarily unavailable during this time — your work will be safe.',
    scheduledFor: 'Scheduled for {window}',
    inEffectSince: 'In effect since {time}',
    fullAccessExpectedBy: 'Full access expected by {time}',
    collapseMaintenanceMessage: 'Collapse maintenance message',
    expandMaintenanceMessage: 'Show maintenance message',
    resetToView: 'Reset to',
    resetToDefault: 'Reset to Default',
    clearSelection: 'Clear selection',
    itemsSelected: 'items selected',
    selectAction: 'Select action',
    clickToEdit: 'Click to edit',
    copy: 'Copy',
    copied: 'Copied',
    copyFailed: 'Could not copy to clipboard',
    sendEmail: 'Send email',
    sendEmailTo: 'Send email to {email}',
    invalidEmailFormat: '{field} must be a valid email address',
    today: 'Today',
    apply: 'Apply',
    search: 'Search',

    // Calendar
    january: 'January',
    february: 'February',
    march: 'March',
    april: 'April',
    may: 'May',
    june: 'June',
    july: 'July',
    august: 'August',
    september: 'September',
    october: 'October',
    november: 'November',
    december: 'December',

    sun: 'Sun',
    mon: 'Mon',
    tue: 'Tue',
    wed: 'Wed',
    thu: 'Thu',
    fri: 'Fri',
    sat: 'Sat',

    // Workflow Hub
    onboarding: 'Onboarding',
    active: 'Active',
    extension: 'Extension',
    offboarding: 'Offboarding',
    complete: 'Complete',

    // Field Modal
    addCustomField: 'Add custom field',
    editField: 'Edit field',
    fieldName: 'Field name',
    note: 'Note',
    fieldNotePlaceholder: 'Add a note for this field...',
    noteSupportsHtml: 'Note supports HTML formatting',
    displayNoteInGrid: 'Display note on column header',
    displayNoteHelpText: 'When checked, an info icon with a note will appear in the column header',
    inputType: 'Input type',
    colorCodeInput: 'Colour code input',
    allowMultipleSelections: 'Allow multiple selections',
    dropdownOptions: 'Dropdown Options',
    visibleOnStages: 'Visible on stages',
    backToColumns: 'Back to columns',
    customColumn: 'Custom column',
    retainColumnData: 'Retain Column Data',
    retainColumnDataDescription: 'Retains the column data for the same assignment ID across all new records',

    // Input Types
    inputTypeText: 'Text',
    inputTypeYesNo: 'Yes/No',
    inputTypeDropdown: 'Dropdown',
    inputTypeDate: 'Date',
    inputTypeNumber: 'Number',
    inputTypeEmail: 'Email',
    inputTypeChecklist: 'Checklist',
    blank: '(blank)',

    // Messages
    fieldCreated: 'Custom field created successfully',
    fieldUpdated: 'Field updated successfully',
    fieldDeleted: 'Field deleted successfully',
    noCustomFieldsAvailable: 'No more Custom Fields available. Please, create new or remove the existing ones.',

    // Form placeholders and labels
    selectOptions: 'Select options',
    selectOption: 'Select option',
    selectDate: 'Select date',
    editColumns: 'Edit columns',
    clear: 'Clear',
    clearAll: 'Clear All',
    showMore: 'Show more',
    typeToFilter: 'Type to filter...',
    enterValue: 'Enter value...',
    startDate: 'Start date',
    endDateOptional: 'End date (optional)',
    noRecordsFound: 'No records found',
    searchCharLimit: 'Search is limited to 100 characters',
    loading: 'Loading...',
    previous: 'Previous',
    next: 'Next',
    showingRecords: '{start}-{end} of {total}',
    rowsPer: 'Rows per page',
    showChangesInProgress: 'Items in Progress',
    moveTo: 'Move to',
    bulkAction: 'Bulk action',
    messages: 'Messages',
    markAsRead: 'Mark as read',
    markAsUnread: 'Mark as unread',
    message: 'Message',
    mute: 'Mute',
    unmute: 'Unmute',
    messageNotifications: 'Message notifications',
    on: 'On',
    off: 'Off',
    messageNotificationsShowLabel: 'Show message notifications',
    messageNotificationsShowDescription: 'Unread counts on rows and tabs and important flags.',
    messageNotificationsWarningTitle: 'Nothing will tell you a message has arrived.',
    messageNotificationsWarningBody: 'No unread counts and no important flags — including on a message a client has escalated to you. Hover previews still work. Conversations are not deleted or muted for anyone else: threads stay where they are and you can open any of them at any time, you just have to go looking. Reading a thread while notifications are off does not mark it read, so nothing is lost while you are away from it. This changes your view only, on every tab and every client.',
    messageNotificationsSaveError: 'Could not save your preference',
    messageNotificationsSaveErrorRetry: 'Please try again.',
    areYouSure: 'Are you sure?',
    moveToSuccess: 'Successfully moved {count} record(s).',
    moveToFailed: 'Failed to move {count} record(s){details}',
    moveToPartial: 'Successfully moved {success} record(s). {failed} record(s) failed{details}',
    moveToError: 'An error occurred while moving records.',
    partialSuccess: 'Partial Success',
    itemsUpdatedSuccess: '{count} item(s) updated successfully',
    failedToUpdateItems: 'Failed to update items',
    actionFailed: 'Failed to perform action',
    actionSuccess: '{action} complete.',
    reprocessTriggered: 'Reprocess started — refreshing in a moment.',
    processingActionSingle: 'Applying your changes, this may take a moment...',
    processingActionMultiple: 'Applying changes to {count} items, this may take a moment...',
    processing: 'Processing...',
    noActionsAvailable: 'No actions available',
    noActionsHint: 'Selected items may be in different states or conditions.',
    confirmDeleteOption: 'Are you sure you want to remove this option?',
    noSuggestions: 'No suggestions found',
    confirmAction: 'Confirm Action',
    actionConfirmMessage: 'Are you sure you want to proceed with this action? This cannot be undone.',
    notes: 'Notes',
    optional: 'Optional',
    addNotesPlaceholder: 'Add any additional notes or comments here...',
    selectedItems: 'selected items',

    // View Selector
    myViews: 'My views',
    sharedWithMe: 'Shared with me',
    allCompany: 'All company',
    saveViewAs: 'Save view as',
    title: 'Title',
    myCustomView: 'My custom view',
    description: 'Description',
    deleteViewConfirmation: 'Are you sure you want to delete this view?',
    deleteViewWarning: 'This view will be deleted for everyone it has been shared with. You cannot undo this action.',
    share: 'Share',
    saveChanges: 'Save changes',
    changesSuccess: 'Changes saved successfully',
    saveAsNew: 'Save as new',
    deleteView: 'Delete view',
    viewNotFound: 'View not found. It may have been deleted.',
    hideView: 'Hide view',
    saveView: 'Save view',
    saveThisView: 'Save this view',
    visibility: 'Visibility',
    private: 'Private',
    public: 'Public',
    clientFacing: 'Client facing',

    // Edit Columns Modal
    hiddenColumns: 'Hidden columns',
    visibleColumns: 'Visible columns',
    editColumnsSubtitle: 'Hide, show, order, edit and create custom columns.',
    moveToTop: 'Move to top',
    moveToBottom: 'Move to bottom',
    nameYourCustomView: 'Name your custom view',

    // Manage Views Modal
    manageViews: 'Manage views',
    searchViews: 'Search views',
    showView: 'Show view',
    view: 'View',
    editView: 'Edit view',
    createView: 'Create view',
    noMyViews: 'No views found',
    noPublicViews: 'No public views found',
    viewSavedSuccessfully: 'View saved successfully',
    columnConfigurationUpdatedSuccessfully: 'Column configuration updated successfully',
    failedToSaveView: 'Failed to save view',
    unsavedChangesTitle: 'Unsaved Changes',
    unsavedChanges: 'You have unsaved changes',
    unsavedChangesWarning: 'You have unsaved changes to your filters. Switching views will discard these changes. Are you sure you want to continue?',
    dismissError: 'Dismiss error',
    refreshView: 'Refresh view',
    refreshViewTitle: 'Refresh view?',
    refreshViewMessage: 'Reloading this view will discard any unsaved filter changes. Continue?',
    switchView: 'Switch View',
    automations: 'Automations',

    // Audit History
    searchChanges: 'Search changes...',
    loadingHistory: 'Loading history...',
    noChangesFound: 'No changes found',
    changesFound: 'changes found',
    changeFound: 'change found',
    new: 'New',
    by: 'by',
    unknownUser: 'Unknown User',
    unknownDate: 'Unknown date',
    changeReason: 'Note',
    changes: 'Changes',
    loadMore: 'Load More',
    viewHistory: 'View History',
    viewMessages: 'View Messages',
    pinTooltip: 'Drag and drop this pin onto any column to pin it.',
    unpinTooltip: 'Click to unpin this column or drag and drop it to another one.',
    confirmUpdateMessage: 'You are about to update {count} record(s) with this bulk action. Do you want to proceed?',
    seconds: 'seconds',
    confirmUpdate: 'Confirm Update',
    confirm: 'Confirm',
    yes: 'Yes',
    no: 'No',
    someValuesEmpty: 'Some values are empty and will clear the existing data.',
    viewSelector: 'View selector',

    // Additional Audit History translations
    all: 'All',
    lastWeek: 'Last Week',
    lastMonth: 'Last Month',
    '90days': '90 Days',
    lastYear: 'Last Year',
    custom: 'Custom',
    stage: 'Stage',
    true: 'True',
    false: 'False',
    changeHistory: 'Change History',
    automationEmails: 'Automation Emails',
    historyOf: 'History of',
    candidate: 'Candidate',
    allStages: 'All Stages',
    allUsers: 'All Users',
    adjustSearchFilters: 'Try adjusting your search or filters',
    showing: 'Showing',
    change: 'change',
    additionalInfo: 'Additional Info',
    clickToExpand: 'Click to expand details',
    clickToCollapse: 'Click to collapse details',
    endDate: 'End Date',
    of: 'of',
    sentTo: 'Sent to',
    sentFrom: 'From',
    sentAt: 'Sent at',
    subject: 'Subject',
    noEmailsFound: 'No emails found',
    loadingEmails: 'Loading emails...',
    searchEmailSubject: 'Search email subject...',
    automationEmailHistoryOf: 'Automation Email History of',
    refresh: 'Refresh',
    refreshAutomationEmails: 'Refresh automation emails',
    refreshChangeHistory: 'Refresh change history',
    stages: 'Stages',
    selectRecipient: 'Select recipient',
    to: 'To',
    from: 'From',
    showLess: 'Show less',
    min: 'Min',
    max: 'Max',
    auto: 'Auto',
    selectAll: 'Select all',

    // Worker Search
    searchWorkers: 'Search Workers',
    searchWorker: 'Search Worker',
    workerName: 'Worker Name',
    clientName: 'Client',
    workOrderId: 'Work Order ID',
    searchHelperText: 'Type at least 2 characters to search for workers',

    // Private Columns
    whoCanViewColumn: 'Who can view this column',
    noUsersSelected: 'No users selected',
    updateColumnAccess: 'Update column access',
    confirmMakePrivate: 'Make Column Private',
    confirmMakePrivateMessage: 'Only users with access will be allowed to see this column.',
    confirmMakePublic: 'Make Column Public',
    confirmMakePublicMessage: 'This column will become public and visible to everyone. Authorized users will be reset.',

    // Private Column
    privateColumn: 'Private column:',
    clientVisibleColumn: 'Client Visible Column',

    // View Manager
    vmTitle: 'View Designer',
    vmStepColumns: 'Columns',
    vmStepFields: 'Fields',
    vmStepFilters: 'Filters',
    vmDiscardTitle: 'Discard unsaved changes?',
    vmDiscardDescription: 'You have unsaved changes that will be lost if you close the View Manager.',
    vmKeepEditing: 'Keep editing',
    vmCategoryPrivate: 'My Views',
    vmCategoryClient: 'Client',
    vmCategoryDefault: 'Default',
    vmNoViews: 'No views found in this category',
    vmSelectViewFirst: 'Select a view from the Views tab to get started',
    vmApplyToStages: 'Apply to stages',
    vmBackToViews: 'Back to Views',
    vmViewProperties: 'View Properties',
    vmEditColumns: 'Edit Columns & Filters',
    vmFilterType: 'Show',
    vmColumnPreview: 'Table Preview',
    vmClientOrgs: 'Client Organizations',
    vmNoEditPermission: 'You do not have permission to edit this view',
    vmGlobalFilters: 'Global Filters',
    vmStageFilters: 'Stage Filters',
    vmSearchFields: 'Search fields...',
    vmNoMatchingFields: 'No fields match your search',
    vmNoStageFilters: 'No stage filters configured',
    vmAddFilter: 'Add Filter',
    vmSortedBy: 'Sorted by',
    vmNoSort: 'No default sort',
    vmSelectSortField: 'Select sort field',
    vmAscending: 'Ascending',
    vmDescending: 'Descending',
    vmStageColumnsHelp: 'Select a stage to preview and reorder its columns. Use the grid below to toggle column visibility across stages.',
    vmCopyLayoutTo: 'Copy current stage layout to:',
    vmNone: 'None',
    vmNoVisibleColumns: 'No visible columns for this stage',

    default: '(default)',
    searchUsersPlaceholder: 'Search users by name or email...',
    noUsersFound: 'No users found',
    searchingUsers: 'Searching...',
    typeToSearchUsers: 'Type to search users...',
    typeAtLeastTwoChars: 'Type at least 2 characters...',
    searchAllColumns: 'Search all columns...',
    jumpToColumn: 'Jump to column',
    jumpToColumnPlaceholder: 'Type a column name…',
    noMatchingColumn: 'No matching column',
    addToView: 'Add to view',
    privateColumnWarningTitle: 'Private Column Filters Warning',
    privateColumnWarningMessage: 'This public view contains filters on private columns. Other users who don\'t have access to these private columns may not see the same results or may encounter errors when using this view. Are you sure you want to save this public view?',
    saveAnyway: 'Save Anyway',

    // Checklist Panel
    worker: 'Worker',
    workOrderIdLabel: 'Work Order ID',
    itemsCompleted: 'items completed',
    addNewItem: 'Add new item',
    unsavedChecklistChanges: 'You have unsaved changes to',
    unsavedChecklistMessage: 'Are you sure you want to close without saving?',

    // Checklist Audit
    added: 'Added',
    removed: 'Removed',
    completed: 'Completed',
    deleted: 'Deleted',
    restored: 'Restored',
    duplicateItemError: 'An item with this name already exists',
    duplicateItemsPreventSave: 'Cannot save: duplicate checklist items found. Please ensure all items have unique names.',

    // Column positioning and date formatting
    fixedPosition: 'Fixed Position',
    dateFormatting: 'Date Formatting',
    shortDateFormat: 'Short Date (MM/DD/YYYY)',
    dateTimeFormat: 'Date Time (MM/DD/YYYY HH:MM)',
    manageColumnsDescription: 'Manage column visibility and order for {stage}',

    // Extend Work Order Modal
    extendWorkOrder: 'Extend Work Order',
    extendWorkOrderQuestion: 'Do you have a new placement ID for this extension?',
    newPlacementId: 'New placement ID',
    enterPlacementId: 'Enter Placement ID',
    invalidPlacementId: 'Invalid Placement ID',
    failedValidateAtsPlacement: 'Failed to validate ATS placement',
    extensionCreatedSuccess: 'Extension created successfully',
    extensionCreatedSuccessFor: 'Extension created successfully for work order',
    viewExtensionInFbo: 'View Extension in FBO',
    processingExtension: 'Processing extension, please wait...',
    extensionChangesWillAppearSoon: 'It may take a few moments for changes to be reflected on Workflow Hub.',
    failedCreateExtension: 'Failed to create extension',
    errorExtendingWorkOrder: 'An error occurred while extending the work order',
    continueWithoutPlacementId: 'Continue without Placement ID',
    validateAndExtend: 'Validate & Extend',
    submit: 'Submit',
    client: 'Client',
    lineOfBusiness: 'Line of Business',
    dates: 'Dates',
    continueWithWarning: 'Continue despite warning',
    areYouSureExtend: 'Are you sure you want to extend this work order?',
    extensionWorkOrderCreationFailed: 'Extension Work Order Creation Failed',
    createExtensionManually: 'Click the link below to view the work order in FBO.',
    clientMismatch: 'Client mismatch: Placement client is "{placementClient}" but current client is "{currentClient}"',
    workerMismatch: 'Worker mismatch: Placement worker is "{placementWorker}" but current worker is "{currentWorker}"',
    extensionAlreadyScheduledDescription: 'This assignment already has a future extension work order that has not yet taken effect.',
    extendExistingExtensionQuestion: 'Would you like to create an extension of that work order instead?',
    extendExistingExtension: 'Proceed with Extension',
    openWorkOrder: 'Open work order',
    // Client Requests Tab
    requests: 'Requests',
    clientRequests: 'Client Requests',
    tasks: 'Tasks',
    showCompleted: 'Show Completed',

    // Grid column labels
    status: 'Status',
    requestTypeLabel: 'Type',
    requestedBy: 'Requested By',
    dateRequested: 'Date Requested',
    clientOrg: 'Client Org',
    workerOrg: 'Worker Org',
    profileType: 'Profile Type',
    billRate: 'Bill Rate',
    payRate: 'Pay Rate',

    // Facet label
    requestTypeFacet: 'Request Type',

    // Status badge keys
    statusDraft: 'Draft',
    statusInitiated: 'Request Initiated',
    statusVerifyingWorker: 'Pre-Verification Requested',
    statusReviewWorkerInfo: 'Pre-Verification Review',
    statusWorkerInfoReviewed: 'Pre-Verification Complete',
    statusNew: 'New',
    statusPreVerificationRequested: 'Pre-verification Requested',
    statusPreVerificationReview: 'Pre-verification Review',
    statusPreVerificationComplete: 'Pre-verification Complete',
    statusAccepted: 'Request Accepted',
    statusCancelled: 'Canceled',
    // VMS-only: pre-verification was Discarded on gw-sync; underlying VMS
    // request is still actionable. Distinct from statusCancelled.
    statusRejected: 'Pre-Verification Rejected',
    statusOnHold: 'On Hold',
    statusInProgress: 'In Progress',
    statusAtsAccepted: 'Accepted',
    statusAtsCancelled: 'Cancelled',

    // Request type keys
    requestTypeOnboarding: 'Onboarding',
    requestTypeGeneral: 'General',
    requestTypeExtension: 'Extension',
    requestTypeRedeployment: 'Redeployment',
    requestTypeTermination: 'Termination',
    requestTypeOther: 'Other',
    requestTypePreOnboarding: 'Pre-Onboarding',

    // Detail panel keys
    requestDetailsHeader: 'Request Details',
    requestInfo: 'Request Info',
    consultantInfo: 'Consultant Info',
    terminationDetailsSection: 'Termination Details',
    attachmentsLabel: 'Attachments',
    requestDetailsField: 'Request Details',
    workerFullName: 'Worker Full Name',
    assignedTo: 'Assigned To',
    billRateUnit: 'Bill Rate Unit',
    rateLabel: 'Rate',
    rateUnitLabel: 'Rate Unit',
    terminationDetailsField: 'Termination Details',
    jobTitleLabel: 'Job Title',
    hiringManager: 'Hiring Manager',
    hiringManagerEmail: 'Hiring Manager Email',

    // Grid UI strings
    noOptionsAvailable: 'No options available',
    noRecords: 'No records',

    // Client Request Action labels
    actionStartPreVerification: 'Start Pre-verification',
    actionProceedToOnboarding: 'Start Onboarding',
    actionViewPreverification: 'View Preverification',
    actionAcknowledge: 'Acknowledge',
    actionCancelRequest: 'Cancel Request',
    actionOnHold: 'On Hold',

    // Client Request Action Modal
    notesRequired: 'Notes (Required)*',
    unknownWorker: 'Unknown Worker',
    // New Onboarding Request button
    newOnboardingRequest: 'New Onboarding Request',

    // Client Request Modal
    requestExtensionTitle: 'Request Extension',
    requestTerminationTitle: 'Request Termination',
    requestRedeploymentTitle: 'Request Redeployment',
    requestOtherChangesTitle: 'Request Other Changes',
    requestSubmitted: 'Request submitted',
    requestSubmittedSuccess: 'Your change request has been submitted successfully.',
    submissionFailed: 'Submission failed',
    submissionError: 'An error occurred while submitting your request.',
    hiringManagerNameLabel: 'Hiring Manager Name',
    includeRateUpdate: 'Include rate update',
    submitRequest: 'Submit Request',
    submitting: 'Submitting...',
    onboardingSuccess: 'Onboarding submitted successfully',
    onboardingFailed: 'Onboarding submission failed',
    warning: 'Warning',
    preVerificationCloseFailed: 'Onboarding started, but the linked pre-verification was not closed. Review it before changing it.',
    vmsAcceptFailedAfterOnboarding: "Onboarding started, but the VMS request couldn't be marked as accepted. Any linked pre-verification was left open.",
    clientRequestCloseFailedAfterOnboarding: "Onboarding started, but the client request couldn't be marked as accepted. Review it before changing it.",
    clientRequestLinkFailedAfterOnboarding: "Onboarding started, but the client request couldn't be linked to the work order, so its job description won't carry over.",
    request: 'Request',
    enterJobTitlePlaceholder: 'Enter job title',
    fullNamePlaceholder: 'Full name',
    emailPlaceholder: 'email@example.com',
    ratePlaceholder: 'e.g. 85.00',
    rateUnitPlaceholder: 'e.g. Hourly',
    currentEndDate: 'Current End Date',
    currentRate: 'Current Rate',
    rateUnitHour: 'Hour',
    rateUnitDay: 'Day',
    rateUnitFixed: 'Fixed',
    rateUnitWords: 'Words',
    rateUnitMonthly: 'Monthly',
    rateUnitShift: 'Shift',
    terminationDetailsPlaceholder: 'Provide termination details...',
    requestDetailsPlaceholder: 'Describe your request...',
    manageCustomFields: 'Manage custom fields',
    suggestions: 'Suggestions:',
    clearSearch: 'Clear search',
    actions: 'Actions',
    deleteCustomFieldConfirmTitle: 'Are you sure you want to remove "{name}"?',
    deleteCustomFieldConfirmBody: '"{name}" will be removed from settings and views. This action cannot be undone.',
    deleteFailed: 'Failed to delete the field.',

    // Request Progress Panel — actor type labels
    actorTypeWorker: 'Worker',
    actorTypeClientServices: 'Client Services',
    actorTypeAccountManager: 'Account Manager',
    actorTypeExecutive: 'Executive',
    actorTypeRecruiter: 'Recruiter',
    actorTypeSubvendorOrg: 'Subvendor Org',
    actorTypeSubvendorWorker: 'Subvendor Worker',
    actorTypeReadOnly: 'Read Only',
    rppTitle: 'Request Progress',
    rppLoadingRequests: 'Loading requests…',
    rppNoRequests: 'No requests found for this assignment.',
    rppLoadError: 'Unable to load request information. Please try again later.',
    rppNoAssignees: 'No assignees',
    rppAssigneesCount: 'Assignees · {count}',
    rppDragHoverHint: '— drag · hover avatars',
    rppActorDetails: 'Actor Details',
    rppCompletedOn: 'Completed on',
    // Related Requests Panel — UI strings
    rrpTitle: 'Related Requests',
    rrpLoadingRequests: 'Loading related requests…',
    rrpNoRequests: 'No related requests found for this assignment.',
    rrpLoadError: 'Unable to load related requests. Please try again later.',
    rrpDetailLoadError: 'Unable to load request details.',
    rrpLoadingDetail: 'Loading details…',
    rrpCommentsHeader: 'Comments',
    rrpNoComments: 'No comments.',
    rrpRequestDateLabel: 'Request Date',
    rrpActionedBy: 'Actioned By',
    rrpOpenOnboardingRequest: 'Open onboarding request',
    rrpAnticipatedStartDate: 'Anticipated Start Date',
    rrpExpandPanel: 'Expand panel',
    rrpCollapsePanel: 'Collapse panel',
    // ATS Placements
    atsCreateSuccess: 'Placement {id} added to the ATS queue.',
    atsCreateNotFound: 'No placement found for ATS ID {id}. Please check the ID and try again.',
    atsCreateError: 'Failed to fetch ATS data. Please contact support.',
    atsStartPreVerificationFailed: 'Failed to start pre-verification. Please try again.',
    atsResyncFailed: 'Failed to re-sync placement. Please try again.',
    atsResyncSuccess: 'Placement {id} re-synced successfully.',
    atsCreateInFboFailed: 'Failed to create onboarding session. Please try again.',
    atsAcceptFailedAfterOnboarding: "Onboarding started, but the ATS placement couldn't be marked as accepted. Any linked pre-verification was left open.",
    atsLoadPlacementsFailed: 'Failed to load placements.',
    atsNoPlacementsPendingReview: 'No placements pending review.',
    atsAssignUserFailed: 'Failed to save assigned user. Please try again.',
    atsCreateModalTitle: 'Create New ATS Placement',
    atsPlacementIdLabel: 'ATS Placement ID',
    atsPlacementIdPlaceholder: 'Enter ATS placement ID',
    atsCreateButton: 'Create',
    atsCreatingButton: 'Creating...',
    atsCreateDuplicate: 'ATS ID {id} is already in the queue.',
    atsCreateDuplicateWorker: 'Worker',
    atsCreateDuplicateClient: 'Client',
    atsCreateDuplicateQuestion: 'Do you want to proceed anyway?',
    atsCreateProceed: 'Yes, proceed',
    atsCancelModalTitle: 'Cancel Request',
    atsSourceName: 'ATS queue',
    atsPlacementNoun: 'placement',
    atsHoldActionName: 'Place on Hold',
    // ATS Sync Settings
    atsSyncCreateNewAts: 'Create New ATS',
    atsSyncInclusionSettingsLabel: 'ATS Sync Inclusion Settings',
    atsSyncSearchLabel: 'Search clients by name',
    atsSyncSearchPlaceholder: 'Search by client name or ATS ID...',
    atsSyncFilters: 'Filters',
    atsSyncStatus: 'Status',
    atsSyncStatusAll: 'All',
    atsSyncStatusEnabled: 'Enabled',
    atsSyncStatusDisabled: 'Disabled',
    atsSyncWarningsOnly: 'With warnings only',
    atsSyncUnmappedOnly: 'Unmapped only',
    atsSyncCountry: 'Country',
    atsSyncAny: 'Any',
    atsSyncProvinceState: 'Province / State',
    atsSyncSelectCountryFirst: 'Select a country first',
    atsSyncSearchCountry: 'Search countries...',
    atsSyncSearchSubdivision: 'Search provinces / states...',
    atsSyncNoResults: 'No results',
    atsSyncCity: 'City',
    atsSyncNoClientsMatch: 'No clients match the current filters',
    atsSyncModalTitle: 'ATS Sync — Inclusion Settings',
    atsSyncModalSubtitle: 'Configure which clients and lines of business are included in ATS sync.',
    atsSyncUnmappedClientsLabel: 'Unmapped clients (default)',
    atsSyncUnmappedClientsSubtitle: 'Applies to ATS placements with no mapped FBO client',
    atsSyncUnmappedClientsTooltip: 'These rules apply to all ATS placements whose client is not mapped to an FBO organization. Enable a line of business to auto-create those placements with an empty client; leave this empty to skip them.',
    atsSyncClientsEnabled: '{count} clients enabled',
    atsSyncClientsShown: '{shown} of {total} clients shown',
    atsSyncClientsTotal: '{total} clients',
    atsSyncUnsavedChange: '· {count} unsaved change',
    atsSyncUnsavedChanges: '· {count} unsaved changes',
    atsSyncApplyToAll: 'Apply to all ({count})',
    atsSyncSaving: 'Saving...',
    atsSyncNoMappingTooltip: 'No ATS client is mapped to this FBO client. Auto-sync will not pick up placements for this client.',
    atsSyncDuplicateSingleTooltip: 'ATS ID {id}{name} is mapped to more than one FBO client. Auto-sync cannot determine which client to use.',
    atsSyncDuplicateMultipleTooltip: 'ATS IDs {ids} are each mapped to more than one FBO client. Auto-sync cannot determine which client to use.',
    atsSyncApplyToAllTitle: 'Apply to All',
    atsSyncApplyToAllBodySingular: 'The selected LOB settings will be applied to {count} client. This will overwrite their current settings.',
    atsSyncApplyToAllBodyPlural: 'The selected LOB settings will be applied to {count} clients. This will overwrite their current settings.',
    atsSyncAllClients: 'All clients',
    atsSyncAllLinesOfBusiness: 'All lines of business',
    atsSyncApplyToCount: 'Apply to {count}',
    // Export Modal
    exportToExcel: 'Export to Excel',
    exportScope: 'Scope',
    current: 'current',
    rows: 'rows',
    exportColumnsForStage: 'Columns for {stage}',
    exportExcludeInternal: 'Exclude {count} internal-only column(s)',
    exportShowVisibleOnly: 'Show visible columns only',
    exportShowAllColumns: 'Show all columns…',
    exportNoColumns: 'No columns available',
    exportNotClientFacing: 'Not client-facing',
    exportPrivateColumn: 'Private column',
    exportWarnNotClientFacingCount: 'column(s) are flagged as not client-facing',
    exportWarnNotClientFacingBody: 'Don\'t share this file with clients.',
    exportWarnPrivateCount: 'private column(s) included',
    exportWarnPrivateBody: 'These are internal-only — exclude before any external share.',
    exportTooLarge: 'Export too large',
    exportFilename: 'Filename',
    exportFilenameHint: '.xlsx is added automatically if you leave it off.',
    exporting: 'Exporting…',
    exportRowsButton: 'Export {count} rows',
    exportUnexpectedError: 'Unexpected error',
    exportServerError: 'Server returned {status}',
    // VMS Integration Settings
    vmsSettingsTitle: 'VMS Integration Settings',
    vmsSkipPublicDomainFilterLabel: 'Accept public-domain senders',
    vmsSkipPublicDomainFilterNote: 'When ON, emails from gmail / outlook / yahoo / other public mail providers auto-create a request. When OFF (default), they are parked at "Pending manual create" for review. Cascades to every client linked to this tenant.',
    vmsTenant: 'Tenant',
    vmsAllTypes: 'All Types',
    vmsActiveOnly: 'Active Only',
    vmsSearchPlaceholder: 'Search by name or client...',
    vmsNoSettingsMatch: 'No settings match your filters.',
    vmsSelectSetting: 'Select a setting or create a new one.',
    vmsInactive: 'Inactive',
    vmsCopyEmail: 'Copy email address',
    vmsEmailsReceived: 'email(s) received',
    vmsLast: 'Last',
    vmsFboClient: 'FBO Client',
    vmsClientReadOnly: 'Client cannot be changed. To use a different client, create a new setting.',
    vmsDisplayName: 'Display Name',
    vmsNotesOptional: 'Notes (optional)',
    vmsNotesPlaceholder: 'Internal notes...',
    vmsTypeLabel: 'VMS Type',
    vmsTypeNone: 'None — detect per email',
    vmsTypeNote: 'When set, this type is applied to every request created from emails on this endpoint, overriding the per-email LLM guess.',
    vmsDefaultAssignees: 'Default Assignees',
    vmsSearchUsers: 'Search users...',
    vmsPrimaryAssignee: 'Primary — assigned automatically',
    vmsPrimaryAssigneeNote: 'The first assignee is pre-populated on new requests; the rest are stored for quick reassignment.',
    vmsLoadedHint: 'Showing {loaded} of {total}',
    vmsLoadingMore: 'Loading...',
    vmsMainInfo: 'Main info',
    vmsVersionTooltip: 'Version {n}. Each semantic edit creates a new version; cosmetic edits (display name, notes, active toggle) mutate in place.',
    vmsHistorySection: 'History',
    vmsNoAuditEntries: 'No audit entries yet.',
    vmsCopySuccess: 'Email address copied to clipboard.',
    vmsCopyInactiveWarning: 'This configuration is inactive — email sent to this address will not be associated with this client until it is reactivated.',
    vmsRowCopyEmail: 'Copy email address',
    vmsDiscard: 'Discard',
    vmsDeleteSetting: 'Delete Setting',
    vmsDeleteConfirm: 'Are you sure you want to delete',
    vmsDeleteEmailWarning: 'The email address will stop receiving new emails.',
    vmsDeleting: 'Deleting...',
    vmsNewTenantSetting: 'New Tenant Email Setting',
    vmsNewClientSetting: 'New Client Email Setting',
    vmsTenantDescription: 'Organization-wide VMS inbox shared across all clients.',
    vmsClientDescription: 'VMS inbox tied to a specific FBO client.',
    vmsSearchClient: 'Search by client name...',
    vmsChangeClient: 'Change client',
    vmsTenantNameExample: 'e.g. Main VMS Inbox',
    vmsClientNameExample: 'e.g. ACME Corp VMS',
    vmsLlmConfig: 'LLM Configuration',
    vmsLlmConfigDescription: 'Model and token settings for VMS email parsing with this configuration. Client settings inherit from the linked tenant configuration.',
    vmsDefaultLlmConfig: 'Set as default LLM configuration for this tenant',
    vmsModel: 'Model',
    vmsMaxTokens: 'Max Tokens',
    vmsCustomPrompt: 'Custom Prompt Instructions (optional)',
    vmsCustomPromptPlaceholder: 'Additional instructions appended to the default extraction prompt. Leave empty to use built-in defaults with standard safety railguards.',
    vmsPromptSafetyNote: 'Built-in prompt injection protection and safety railguards are always applied regardless of custom instructions.',
    vmsEmailDomain: 'Email domain:',
    vmsEmailDomainNote: 'Changing the domain requires updating server configuration and the email service provider. Existing email addresses will stop working if the domain is changed.',
    vmsDiscardConfirm: 'You have unsaved changes. Do you want to discard them and continue?',
    vmsGoBack: 'Go Back',
    vmsDiscardContinue: 'Discard & Continue',
    // Added: previously-missing keys
    allowDataExport: 'Allow data export',
    alsoSaveChangesOn: 'Other tabs with unsaved changes',
    alsoSaveChangesOnHelp: 'Saving will also persist changes you made on these tabs. Uncheck any you want to leave as drafts.',
    applyChanges: 'Apply Changes',
    atsSyncSettings: 'ATS Sync Settings',
    bulkEditDescription: 'Updating {count} selected item(s)',
    bulkUpdateError: 'Bulk update failed',
    bulkUpdateErrorDesc: 'An error occurred during bulk update.',
    bulkUpdateFailed: 'Failed to update {count} record(s){details}',
    bulkUpdatePartial: 'Successfully updated {success} record(s). {failed} record(s) failed{details}',
    bulkUpdateSuccess: 'Successfully updated {count} record(s).',
    done: 'Done',
    export: 'Export',
    field: 'Field',
    hours: 'Hours',
    minutes: 'Minutes',
    noFieldsSelected: 'No fields selected',
    originalEmail: 'Original email',
    pleaseSelectAtLeastOneField: 'Please select at least one field.',
    removeField: 'Remove field',
    selectEndDate: 'Select end date...',
    selectField: 'Select field...',
    selectFieldFirst: 'Select a field first',
    selectStartDate: 'Select start date...',
    time: 'Time',
    updatesView: 'updates',
    value: 'Value',
    viewAllowDataExportEnabled: 'Data export is enabled for this view',
    vmAllowDataExportHelp: 'When on, users with the Export Data permission can export this view to Excel.',
    vmExportDisabled: 'Export Disabled',
    vmExportEnabled: 'Export Enabled',
    vmRevert: 'Revert Changes',
    // Messages inbox filters
    inboxSearchPlaceholder: 'Search by worker name, Work Order #, ATS ID, or VMS ID',
    inboxFilters: 'Filters',
    inboxFilterDate: 'Last message date',
    inboxFilterFrom: 'From',
    inboxFilterTo: 'To',
    inboxFilterWorkOrderStages: 'Work order stages',
    inboxFilterRequests: 'Requests',
    inboxFilterSender: 'Sender',
    inboxFilterAny: 'Any',
    inboxFilterSelectedCount: '{count} selected',
    inboxNoMatches: 'No messages match your filters.',
  },
  fr: {
    // Common
    success: 'Succès',
    error: 'Erreur',
    cancel: 'Annuler',
    save: 'Enregistrer',
    delete: 'Supprimer',
    edit: 'Modifier',
    add: 'Ajouter',
    back: 'Retour',
    editWorkItems: 'Modifier les éléments',
    addNewField: 'Ajouter un champ',
    close: 'Fermer',
    ok: 'OK',
    option: 'Option',
    filter: 'Filtre',
    clearFilters: 'Effacer les filtres',
    activeFilters: 'Filtres actifs',
    globalFilters: 'Filtres globaux',
    stageFiltersHeading: "Filtres de l'étape {stage}",
    clearAllFilters: 'Effacer tous les filtres',
    bannerTitleInfo: 'Avis',
    bannerTitleWarning: 'Avertissement',
    bannerTitleError: 'Important',
    maintenanceInProgress: 'Maintenance planifiée en cours',
    scheduledMaintenanceUpcoming: 'Maintenance planifiée à venir',
    upcomingMaintenanceBody: 'Une maintenance planifiée est prévue. Certaines actions pourraient être temporairement indisponibles pendant cette période — votre travail sera en sécurité.',
    scheduledFor: 'Planifiée pour {window}',
    inEffectSince: 'En vigueur depuis {time}',
    fullAccessExpectedBy: 'Accès complet prévu d’ici {time}',
    collapseMaintenanceMessage: 'Réduire le message de maintenance',
    expandMaintenanceMessage: 'Afficher le message de maintenance',
    resetToView: 'Réinitialiser à',
    resetToDefault: 'Réinitialiser par défaut',
    clearSelection: 'Effacer la sélection',
    itemsSelected: 'éléments sélectionnés',
    selectAction: 'Sélectionner une action',
    clickToEdit: 'Cliquer pour modifier',
    copy: 'Copier',
    copied: 'Copié',
    copyFailed: 'Impossible de copier dans le presse-papiers',
    sendEmail: 'Envoyer un courriel',
    sendEmailTo: 'Envoyer un courriel à {email}',
    invalidEmailFormat: '{field} doit être une adresse courriel valide',
    today: "Aujourd'hui",
    apply: 'Appliquer',
    search: 'Rechercher',

    // Calendar
    january: 'Janvier',
    february: 'Février',
    march: 'Mars',
    april: 'Avril',
    may: 'Mai',
    june: 'Juin',
    july: 'Juillet',
    august: 'Août',
    september: 'Septembre',
    october: 'Octobre',
    november: 'Novembre',
    december: 'Décembre',

    sun: 'Dim',
    mon: 'Lun',
    tue: 'Mar',
    wed: 'Mer',
    thu: 'Jeu',
    fri: 'Ven',
    sat: 'Sam',

    // Workflow Hub
    onboarding: 'Intégration',
    active: 'Actif',
    extension: 'Prolongations',
    offboarding: 'Départ',
    complete: 'Terminé',

    // Field Modal
    addCustomField: 'Ajouter un champ personnalisé',
    editField: 'Modifier le champ',
    fieldName: 'Nom du champ',
    note: 'Note',
    fieldNotePlaceholder: 'Ajouter une note pour ce champ...',
    noteSupportsHtml: 'La note prend en charge le formatage HTML',
    displayNoteInGrid: 'Afficher la note sur l\'en-tête de colonne',
    displayNoteHelpText: 'Lorsque coché, une icône d\'info avec une note apparaîtra dans l\'en-tête de colonne',
    inputType: "Type d'entrée",
    colorCodeInput: 'Entrée de code couleur',
    allowMultipleSelections: 'Autoriser les sélections multiples',
    dropdownOptions: 'Options de la liste déroulante',
    visibleOnStages: 'Visible sur les étapes',
    backToColumns: 'Retour aux colonnes',
    customColumn: 'Colonne personnalisée',
    retainColumnData: 'Conserver les données de colonne',
    retainColumnDataDescription: 'Conserve les données de colonne pour le même ID d\'affectation dans tous les nouveaux enregistrements',

    // Input Types
    inputTypeText: 'Texte',
    inputTypeYesNo: 'Oui/Non',
    inputTypeDropdown: 'Liste déroulante',
    inputTypeDate: 'Date',
    inputTypeNumber: 'Nombre',
    inputTypeEmail: 'Email',
    inputTypeChecklist: 'Liste de contrôle',
    blank: '(vide)',

    // Messages
    fieldCreated: 'Champ personnalisé créé avec succès',
    fieldUpdated: 'Champ mis à jour avec succès',
    fieldDeleted: 'Champ supprimé avec succès',
    noCustomFieldsAvailable: 'Plus de champs personnalisés disponibles. Veuillez en créer de nouveaux ou supprimer les existants.',

    // Form placeholders and labels
    selectOptions: 'Sélectionner des options',
    selectOption: 'Sélectionner une option',
    selectDate: 'Sélectionner une date',
    editColumns: 'Modifier les colonnes',
    clear: 'Effacer',
    clearAll: 'Tout effacer',
    showMore: 'Afficher plus',
    typeToFilter: 'Tapez pour filtrer...',
    enterValue: 'Entrer une valeur...',
    startDate: 'Date de début',
    endDateOptional: 'Date de fin (optionnel)',
    noRecordsFound: 'Aucun enregistrement trouvé',
    searchCharLimit: 'La recherche est limitée à 100 caractères',
    loading: 'Chargement...',
    previous: 'Précédent',
    next: 'Suivant',
    showingRecords: '{start} à {end} sur {total}',
    rowsPer: 'Lignes par page',
    showChangesInProgress: 'Éléments en cours',
    moveTo: 'Déplacer vers',
    bulkAction: 'Action en lot',
    messages: 'Messages',
    markAsRead: 'Marquer comme lu',
    markAsUnread: 'Marquer comme non lu',
    message: 'Message',
    mute: 'Désactiver les notifications',
    unmute: 'Réactiver les notifications',
    messageNotifications: 'Notifications de messages',
    on: 'Activé',
    off: 'Désactivé',
    messageNotificationsShowLabel: 'Afficher les notifications de messages',
    messageNotificationsShowDescription: 'Compteurs de non-lus sur les lignes et les onglets et indicateurs importants.',
    messageNotificationsWarningTitle: 'Rien ne vous préviendra qu\'un message est arrivé.',
    messageNotificationsWarningBody: 'Aucun compteur de non-lus et aucun indicateur important — y compris pour un message qu\'un client vous a transmis en urgence. Les aperçus au survol restent actifs. Les conversations ne sont ni supprimées ni désactivées pour les autres : les fils restent en place et vous pouvez en ouvrir n\'importe lequel à tout moment, il faut simplement aller les chercher. Lire un fil lorsque les notifications sont désactivées ne le marque pas comme lu, donc rien n\'est perdu pendant votre absence. Ceci ne modifie que votre affichage, sur tous les onglets et tous les clients.',
    messageNotificationsSaveError: 'Impossible d\'enregistrer votre préférence',
    messageNotificationsSaveErrorRetry: 'Veuillez réessayer.',
    areYouSure: 'Êtes-vous sûr ?',
    moveToSuccess: '{count} enregistrement(s) déplacé(s) avec succès.',
    moveToFailed: 'Échec du déplacement de {count} enregistrement(s){details}',
    moveToPartial: '{success} enregistrement(s) déplacé(s) avec succès. Échec de {failed} enregistrement(s){details}',
    moveToError: 'Une erreur s\'est produite lors du déplacement des enregistrements.',
    partialSuccess: 'Succès partiel',
    itemsUpdatedSuccess: '{count} élément(s) mis à jour avec succès',
    failedToUpdateItems: 'Échec de la mise à jour des éléments',
    actionFailed: 'Échec de l\'exécution de l\'action',
    actionSuccess: '{action} terminé.',
    reprocessTriggered: 'Retraitement lancé — actualisation dans un instant.',
    processingActionSingle: 'Application de vos modifications, cela peut prendre un moment...',
    processingActionMultiple: 'Application des modifications à {count} éléments, cela peut prendre un moment...',
    processing: 'Traitement...',
    noActionsAvailable: 'Aucune action disponible',
    noActionsHint: 'Les éléments sélectionnés peuvent être dans des états ou des conditions différents.',
    confirmDeleteOption: 'Êtes-vous sûr de vouloir supprimer cette option ?',
    noSuggestions: 'Aucune suggestion trouvée',
    confirmAction: 'Confirmer l\'action',
    actionConfirmMessage: 'Êtes-vous sûr de vouloir continuer avec cette action ? Cela ne peut pas être annulé.',
    notes: 'Notes',
    optional: 'Optionnel',
    addNotesPlaceholder: 'Ajoutez des notes ou commentaires supplémentaires ici...',
    selectedItems: 'éléments sélectionnés',

    // View Selector
    myViews: 'Mes vues',
    sharedWithMe: 'Partagé avec moi',
    allCompany: 'Toute l\'entreprise',
    saveViewAs: 'Enregistrer la vue sous',
    title: 'Titre',
    myCustomView: 'Ma vue personnalisée',
    description: 'Description',
    deleteViewConfirmation: 'Êtes-vous sûr de vouloir supprimer cette vue ?',
    deleteViewWarning: 'Cette vue sera supprimée pour tous ceux avec qui elle a été partagée. Vous ne pouvez pas annuler cette action.',
    share: 'Partager',
    saveChanges: 'Enregistrer les modifications',
    changesSuccess: 'Modifications enregistrées avec succès',
    saveAsNew: 'Enregistrer comme nouveau',
    deleteView: 'Supprimer la vue',
    viewNotFound: 'Vue introuvable. Elle a peut-être été supprimée.',
    hideView: 'Masquer la vue',
    saveView: 'Enregistrer la vue',
    saveThisView: 'Enregistrer cette vue',
    visibility: 'Visibilité',
    private: 'Privé',
    public: 'Public',
    clientFacing: 'Accessible aux clients',

    // Edit Columns Modal
    hiddenColumns: 'Colonnes masquées',
    visibleColumns: 'Colonnes visibles',
    editColumnsSubtitle: 'Masquer, afficher, ordonner, modifier et créer des colonnes personnalisées.',
    moveToTop: 'Déplacer en haut',
    moveToBottom: 'Déplacer en bas',
    nameYourCustomView: 'Nommez votre vue personnalisée',

    // Manage Views Modal
    manageViews: 'Gérer les vues',
    searchViews: 'Rechercher des vues',
    showView: 'Afficher la vue',
    view: 'Voir',
    editView: 'Modifier la vue',
    createView: 'Créer une vue',
    noMyViews: 'Aucune vue trouvée',
    noPublicViews: 'Aucune vue publique trouvée',
    viewSavedSuccessfully: 'Vue enregistrée avec succès',
    columnConfigurationUpdatedSuccessfully: 'Configuration de colonne mise à jour avec succès',
    failedToSaveView: 'Échec de l\'enregistrement de la vue',
    unsavedChangesTitle: 'Modifications non enregistrées',
    unsavedChanges: 'Vous avez des modifications non enregistrées',
    unsavedChangesWarning: 'Vous avez des modifications non enregistrées dans vos filtres. Changer de vue supprimera ces modifications. Êtes-vous sûr de vouloir continuer ?',
    dismissError: 'Fermer l\'erreur',
    refreshView: 'Actualiser la vue',
    refreshViewTitle: 'Actualiser la vue ?',
    refreshViewMessage: 'Recharger cette vue supprimera les modifications de filtres non enregistrées. Continuer ?',
    switchView: 'Changer de vue',
    automations: 'Automatisations',

    // Audit History
    searchChanges: 'Rechercher des modifications...',
    loadingHistory: 'Chargement de l\'historique...',
    noChangesFound: 'Aucune modification trouvée',
    changesFound: 'modifications trouvées',
    changeFound: 'modification trouvée',
    new: 'Nouveau',
    by: 'par',
    unknownUser: 'Utilisateur inconnu',
    unknownDate: 'Date inconnue',
    changeReason: 'Note',
    changes: 'Modifications',
    loadMore: 'Charger plus',
    viewHistory: 'Historique des vues',
    viewMessages: 'Voir les messages',
    pinTooltip: 'Glissez et déposez cette épingle sur n\'importe quelle colonne pour l\'épingler.',
    unpinTooltip: 'Cliquez pour détacher cette colonne ou faites-la glisser vers une autre.',
    confirmUpdateMessage: 'Vous êtes sur le point de mettre à jour {count} enregistrement{s} avec cette action en lot. Souhaitez-vous continuer ?',
    seconds: 'secondes',
    confirmUpdate: 'Confirmer la mise à jour',
    confirm: 'Confirmer',
    yes: 'Oui',
    no: 'Non',
    someValuesEmpty: 'Certaines valeurs sont vides et effaceront les données existantes.',
    viewSelector: 'Sélecteur de vue',

    // Additional Audit History translations
    all: 'Tous',
    lastWeek: 'Dernière semaine',
    lastMonth: 'Dernier mois',
    '90days': '90 jours',
    lastYear: 'Dernière année',
    custom: 'Personnalisé',
    stage: 'Étape',
    true: 'Vrai',
    false: 'Faux',
    changeHistory: 'Historique des modifications',
    automationEmails: 'Emails d\'automatisation',
    historyOf: 'Historique de',
    candidate: 'Candidat',
    allStages: 'Toutes les étapes',
    allUsers: 'Tous les utilisateurs',
    adjustSearchFilters: 'Essayez d\'ajuster votre recherche ou vos filtres',
    showing: 'Affichage de',
    change: 'changement',
    additionalInfo: 'Informations supplémentaires',
    clickToExpand: 'Cliquer pour développer les détails',
    clickToCollapse: 'Cliquer pour réduire les détails',
    endDate: 'Date de fin',
    of: 'sur',
    sentTo: 'Envoyé à',
    sentFrom: 'De',
    sentAt: 'Envoyé le',
    subject: 'Sujet',
    noEmailsFound: 'Aucun email trouvé',
    loadingEmails: 'Chargement des emails...',
    searchEmailSubject: 'Rechercher le sujet de l\'email...',
    automationEmailHistoryOf: 'Historique des emails d\'automatisation de',
    refresh: 'Actualiser',
    refreshAutomationEmails: 'Actualiser les emails d\'automatisation',
    refreshChangeHistory: 'Actualiser l\'historique des modifications',
    stages: 'Étapes',
    selectRecipient: 'Sélectionner le destinataire',
    to: 'À',
    from: 'De',
    showLess: 'Afficher moins',
    min: 'Min',
    max: 'Max',
    auto: 'Auto',
    selectAll: 'Tout sélectionner',

    // Worker Search
    searchWorkers: 'Rechercher des travailleurs',
    searchWorker: 'Rechercher un travailleur',
    workerName: 'Nom du travailleur',
    clientName: 'Client',
    workOrderId: 'ID de commande de travail',
    searchHelperText: 'Tapez au moins 2 caractères pour rechercher des travailleurs',

    // Private Columns
    whoCanViewColumn: 'Qui peut voir cette colonne',
    noUsersSelected: 'Aucun utilisateur sélectionné',
    updateColumnAccess: 'Mettre à jour l\'accès à la colonne',
    confirmMakePrivate: 'Rendre la colonne privée',
    confirmMakePrivateMessage: 'Seuls les utilisateurs avec accès pourront voir cette colonne.',
    confirmMakePublic: 'Rendre la colonne publique',
    confirmMakePublicMessage: 'Cette colonne deviendra publique et visible à tous. Les utilisateurs autorisés seront remis à zéro.',

    // Private Column
    privateColumn: 'Colonne privée :',
    clientVisibleColumn: 'Colonne visible par le client',

    // View Manager
    vmTitle: 'Concepteur de vues',
    vmStepColumns: 'Colonnes',
    vmStepFields: 'Champs',
    vmStepFilters: 'Filtres',
    vmDiscardTitle: 'Annuler les modifications non enregistrées ?',
    vmDiscardDescription: 'Vous avez des modifications non enregistrées qui seront perdues si vous fermez le gestionnaire de vues.',
    vmKeepEditing: 'Continuer à modifier',
    vmCategoryPrivate: 'Mes vues',
    vmCategoryClient: 'Client',
    vmCategoryDefault: 'Par défaut',
    vmNoViews: 'Aucune vue trouvée dans cette catégorie',
    vmSelectViewFirst: 'Sélectionnez une vue dans l\'onglet Vues pour commencer',
    vmApplyToStages: 'Appliquer aux étapes',
    vmBackToViews: 'Retour aux vues',
    vmViewProperties: 'Propriétés de la vue',
    vmEditColumns: 'Modifier les colonnes et filtres',
    vmFilterType: 'Afficher',
    vmColumnPreview: 'Aperçu du tableau',
    vmClientOrgs: 'Organisations clientes',
    vmNoEditPermission: 'Vous n\'avez pas la permission de modifier cette vue',
    vmGlobalFilters: 'Filtres globaux',
    vmStageFilters: 'Filtres par étape',
    vmSearchFields: 'Rechercher des champs...',
    vmNoMatchingFields: 'Aucun champ ne correspond à votre recherche',
    vmNoStageFilters: 'Aucun filtre d\'étape configuré',
    vmAddFilter: 'Ajouter un filtre',
    vmSortedBy: 'Trié par',
    vmNoSort: 'Pas de tri par défaut',
    vmSelectSortField: 'Sélectionner le champ de tri',
    vmAscending: 'Croissant',
    vmDescending: 'Décroissant',
    vmStageColumnsHelp: 'Sélectionnez une étape pour prévisualiser et réorganiser ses colonnes. Utilisez la grille ci-dessous pour gérer la visibilité.',
    vmCopyLayoutTo: 'Copier la disposition de l\'étape actuelle vers :',
    vmNone: 'Aucun',
    vmNoVisibleColumns: 'Aucune colonne visible pour cette étape',

    default: '(par défaut)',
    searchUsersPlaceholder: 'Rechercher des utilisateurs par nom ou email...',
    noUsersFound: 'Aucun utilisateur trouvé',
    searchingUsers: 'Recherche en cours...',
    typeToSearchUsers: 'Tapez pour rechercher des utilisateurs...',
    typeAtLeastTwoChars: 'Tapez au moins 2 caractères...',
    searchAllColumns: 'Rechercher toutes les colonnes...',
    jumpToColumn: 'Aller à la colonne',
    jumpToColumnPlaceholder: 'Tapez le nom d\'une colonne…',
    noMatchingColumn: 'Aucune colonne correspondante',
    addToView: 'Ajouter à la vue',
    privateColumnWarningTitle: 'Avertissement des filtres de colonnes privées',
    privateColumnWarningMessage: 'Cette vue publique contient des filtres sur des colonnes privées. Les autres utilisateurs qui n\'ont pas accès à ces colonnes privées peuvent ne pas voir les mêmes résultats ou rencontrer des erreurs lors de l\'utilisation de cette vue. Êtes-vous sûr de vouloir enregistrer cette vue publique ?',
    saveAnyway: 'Enregistrer quand même',

    // Checklist Panel
    worker: 'Travailleur',
    workOrderIdLabel: 'ID de commande',
    itemsCompleted: 'éléments complétés',
    addNewItem: 'Ajouter un nouvel élément',
    unsavedChecklistChanges: 'Vous avez des modifications non enregistrées dans',
    unsavedChecklistMessage: 'Êtes-vous sûr de vouloir fermer sans enregistrer?',

    // Checklist Audit
    added: 'Ajouté',
    removed: 'Supprimé',
    completed: 'Complété',
    deleted: 'Supprimé',
    restored: 'Restauré',
    duplicateItemError: 'Un élément avec ce nom existe déjà',
    duplicateItemsPreventSave: 'Impossible d\'enregistrer : des éléments en double ont été trouvés. Veuillez vous assurer que tous les éléments ont des noms uniques.',

    // Column positioning and date formatting
    fixedPosition: 'Position fixe',
    dateFormatting: 'Formatage de date',
    shortDateFormat: 'Date courte (MM/JJ/AAAA)',
    dateTimeFormat: 'Date et heure (MM/JJ/AAAA HH:MM)',
    manageColumnsDescription: 'Gérer la visibilité et l\'ordre des colonnes pour {stage}',

    // Extend Work Order Modal
    extendWorkOrder: 'Prolonger le bon de travail',
    extendWorkOrderQuestion: 'Avez-vous un nouvel ID de placement pour cette extension?',
    newPlacementId: 'Nouvel ID de placement',
    enterPlacementId: 'Entrer l\'ID de placement',
    invalidPlacementId: 'ID de placement invalide',
    failedValidateAtsPlacement: 'Échec de la validation du placement ATS',
    extensionCreatedSuccess: 'Extension créée avec succès',
    extensionCreatedSuccessFor: 'Extension créée avec succès pour le bon de travail',
    viewExtensionInFbo: 'Voir l\'extension dans FBO',
    processingExtension: 'Traitement de l\'extension en cours, veuillez patienter...',
    extensionChangesWillAppearSoon: 'Les modifications peuvent prendre quelques instants avant d\'être visibles dans Workflow Hub.',
    failedCreateExtension: 'Échec de la création de l\'extension',
    errorExtendingWorkOrder: 'Une erreur s\'est produite lors de l\'extension du bon de travail',
    continueWithoutPlacementId: 'Continuer sans ID de placement',
    validateAndExtend: 'Valider et prolonger',
    submit: 'Soumettre',
    client: 'Client',
    lineOfBusiness: 'Ligne d\'affaires',
    dates: 'Dates',
    continueWithWarning: 'Continuer malgré l\'avertissement',
    areYouSureExtend: 'Êtes-vous sûr de vouloir prolonger ce bon de travail?',
    extensionWorkOrderCreationFailed: 'Échec de la création de l\'extension du bon de travail',
    createExtensionManually: 'Cliquez sur le lien ci-dessous pour voir le bon de travail dans FBO.',
    clientMismatch: 'Incompatibilité client : Le client du placement est "{placementClient}" mais le client actuel est "{currentClient}"',
    workerMismatch: 'Incompatibilité travailleur : Le travailleur du placement est "{placementWorker}" mais le travailleur actuel est "{currentWorker}"',
    extensionAlreadyScheduledDescription: 'Cette affectation a déjà une prolongation future qui n\'a pas encore pris effet.',
    extendExistingExtensionQuestion: 'Voulez-vous plutôt créer une prolongation de ce bon de travail?',
    extendExistingExtension: 'Procéder à la prolongation',
    openWorkOrder: 'Ouvrir le bon de travail',
    // Client Requests Tab
    requests: 'Demandes',
    clientRequests: 'Demandes client',
    tasks: 'Tâches',
    showCompleted: 'Afficher terminés',

    // Grid column labels
    status: 'Statut',
    requestTypeLabel: 'Type',
    requestedBy: 'Demandé par',
    dateRequested: 'Date de demande',
    clientOrg: 'Org. du client',
    workerOrg: 'Org. du travailleur',
    profileType: 'Type de profil',
    billRate: 'Taux de facturation',
    payRate: 'Taux de rémunération',

    // Facet label
    requestTypeFacet: 'Type de demande',

    // Status badge keys
    statusDraft: 'Brouillon',
    statusInitiated: 'Demande initiée',
    statusVerifyingWorker: 'Pré-vérification demandée',
    statusReviewWorkerInfo: 'Révision de pré-vérification',
    statusWorkerInfoReviewed: 'Pré-vérification terminée',
    statusNew: 'Nouveau',
    statusPreVerificationRequested: 'Pré-vérification demandée',
    statusPreVerificationReview: 'Pré-vérification en cours',
    statusPreVerificationComplete: 'Pré-vérification complétée',
    statusAccepted: 'Demande acceptée',
    statusCancelled: 'Annulé',
    statusRejected: 'Pré-vérification rejetée',
    statusOnHold: 'En attente',
    statusInProgress: 'En cours',
    statusAtsAccepted: 'Accepté',
    statusAtsCancelled: 'Annulé',

    // Request type keys
    requestTypeOnboarding: "Intégration",
    requestTypeGeneral: 'Général',
    requestTypeExtension: 'Prolongation',
    requestTypeRedeployment: 'Redéploiement',
    requestTypeTermination: 'Résiliation',
    requestTypeOther: 'Autre',
    requestTypePreOnboarding: 'Pré-intégration',

    // Detail panel keys
    requestDetailsHeader: 'Détails de la demande',
    requestInfo: 'Infos de la demande',
    consultantInfo: 'Infos du consultant',
    terminationDetailsSection: 'Détails de résiliation',
    attachmentsLabel: 'Pièces jointes',
    requestDetailsField: 'Détails de la demande',
    workerFullName: 'Nom complet du travailleur',
    assignedTo: 'Assigné à',
    billRateUnit: 'Unité du taux de facturation',
    rateLabel: 'Taux',
    rateUnitLabel: 'Unité de taux',
    terminationDetailsField: 'Détails de résiliation',
    jobTitleLabel: 'Titre du poste',
    hiringManager: "Gestionnaire d'embauche",
    hiringManagerEmail: 'Courriel du gestionnaire',

    // Grid UI strings
    noOptionsAvailable: 'Aucune option disponible',
    noRecords: 'Aucun enregistrement',

    // Client Request Action labels
    actionStartPreVerification: 'Démarrer la pré-vérification',
    actionProceedToOnboarding: 'Démarrer l\'intégration',
    actionViewPreverification: 'Voir la pré-vérification',
    actionAcknowledge: 'Accuser réception',
    actionCancelRequest: 'Annuler la demande',
    actionOnHold: 'En attente',

    // Client Request Action Modal
    notesRequired: 'Notes (Obligatoires)*',
    unknownWorker: 'Travailleur inconnu',
    // New Onboarding Request button
    newOnboardingRequest: "Nouvelle demande d'intégration",

    // Client Request Modal
    requestExtensionTitle: 'Demande de prolongation',
    requestTerminationTitle: 'Demande de résiliation',
    requestRedeploymentTitle: 'Demande de redéploiement',
    requestOtherChangesTitle: "Demande d'autres changements",
    requestSubmitted: 'Demande soumise',
    requestSubmittedSuccess: 'Votre demande de changement a été soumise avec succès.',
    submissionFailed: 'Échec de la soumission',
    submissionError: "Une erreur s'est produite lors de la soumission de votre demande.",
    hiringManagerNameLabel: "Nom du gestionnaire d'embauche",
    includeRateUpdate: 'Inclure la mise à jour du taux',
    submitRequest: 'Soumettre la demande',
    submitting: 'Soumission en cours...',
    onboardingSuccess: 'Intégration soumise avec succès',
    onboardingFailed: "Échec de la soumission de l'intégration",
    warning: 'Avertissement',
    preVerificationCloseFailed: "L'intégration a commencé, mais la pré-vérification liée n'a pas été fermée. Examinez-la avant de la modifier.",
    vmsAcceptFailedAfterOnboarding: "L'intégration a commencé, mais la demande VMS n'a pas pu être marquée comme acceptée. Toute pré-vérification liée est restée ouverte.",
    clientRequestCloseFailedAfterOnboarding: "L'intégration a commencé, mais la demande client n'a pas pu être marquée comme acceptée. Examinez-la avant de la modifier.",
    clientRequestLinkFailedAfterOnboarding: "L'intégration a commencé, mais la demande client n'a pas pu être liée au bon de travail; sa description de poste ne sera donc pas reprise.",
    request: 'Demande',
    enterJobTitlePlaceholder: 'Entrer le titre du poste',
    fullNamePlaceholder: 'Nom complet',
    emailPlaceholder: 'courriel@exemple.com',
    ratePlaceholder: 'ex. 85,00',
    rateUnitPlaceholder: 'ex. Horaire',
    currentEndDate: 'Date de fin actuelle',
    currentRate: 'Taux actuel',
    rateUnitHour: 'Heure',
    rateUnitDay: 'Jour',
    rateUnitFixed: 'Fixe',
    rateUnitWords: 'Mots',
    rateUnitMonthly: 'Mensuel',
    rateUnitShift: 'Quart',
    terminationDetailsPlaceholder: 'Fournir les détails de résiliation...',
    requestDetailsPlaceholder: 'Décrivez votre demande...',
    manageCustomFields: 'Gérer les champs personnalisés',
    suggestions: 'Suggestions :',
    clearSearch: 'Effacer la recherche',
    actions: 'Actions',
    deleteCustomFieldConfirmTitle: 'Êtes-vous sûr de vouloir supprimer « {name} » ?',
    deleteCustomFieldConfirmBody: '« {name} » sera supprimé des paramètres et des vues. Cette action est irréversible.',
    deleteFailed: 'Échec de la suppression du champ.',

    // Request Progress Panel — actor type labels
    actorTypeWorker: 'Travailleur',
    actorTypeClientServices: 'Services client',
    actorTypeAccountManager: 'Chargé de compte',
    actorTypeExecutive: 'Cadre',
    actorTypeRecruiter: 'Recruteur',
    actorTypeSubvendorOrg: 'Org. sous-traitant',
    actorTypeSubvendorWorker: 'Travailleur sous-traitant',
    actorTypeReadOnly: 'Lecture seule',
    rppTitle: 'Progression de la demande',
    rppLoadingRequests: 'Chargement des demandes…',
    rppNoRequests: 'Aucune demande trouvée pour cette affectation.',
    rppLoadError: 'Impossible de charger les informations de la demande. Veuillez réessayer plus tard.',
    rppNoAssignees: 'Aucun assigné',
    rppAssigneesCount: 'Assignés · {count}',
    rppDragHoverHint: '— glisser · survoler les avatars',
    rppActorDetails: 'Détails de l\'acteur',
    rppCompletedOn: 'Complété le',
    // Related Requests Panel — UI strings
    rrpTitle: 'Demandes associées',
    rrpLoadingRequests: 'Chargement des demandes associées…',
    rrpNoRequests: 'Aucune demande associée trouvée pour cette affectation.',
    rrpLoadError: 'Impossible de charger les demandes associées. Veuillez réessayer plus tard.',
    rrpDetailLoadError: 'Impossible de charger les détails de la demande.',
    rrpLoadingDetail: 'Chargement des détails…',
    rrpCommentsHeader: 'Commentaires',
    rrpNoComments: 'Aucun commentaire.',
    rrpRequestDateLabel: 'Date de la demande',
    rrpActionedBy: 'Traité par',
    rrpOpenOnboardingRequest: 'Ouvrir la demande d\'intégration',
    rrpAnticipatedStartDate: 'Date de début prévue',
    rrpExpandPanel: 'Agrandir le panneau',
    rrpCollapsePanel: 'Réduire le panneau',
    // ATS Placements
    atsCreateSuccess: 'Le placement {id} a été ajouté à la file ATS.',
    atsCreateNotFound: 'Aucun placement trouvé pour l\'identifiant ATS {id}. Veuillez vérifier l\'identifiant et réessayer.',
    atsCreateError: 'Échec de la récupération des données ATS. Veuillez contacter le support.',
    atsStartPreVerificationFailed: 'Échec du démarrage de la pré-vérification. Veuillez réessayer.',
    atsResyncFailed: 'Échec de la re-synchronisation du placement. Veuillez réessayer.',
    atsResyncSuccess: 'Placement {id} re-synchronisé avec succès.',
    atsCreateInFboFailed: 'Échec de la création de la session d\'intégration. Veuillez réessayer.',
    atsAcceptFailedAfterOnboarding: "L'intégration a commencé, mais le placement ATS n'a pas pu être marqué comme accepté. Toute pré-vérification liée est restée ouverte.",
    atsLoadPlacementsFailed: 'Échec du chargement des placements.',
    atsNoPlacementsPendingReview: 'Aucun placement en attente de révision.',
    atsAssignUserFailed: 'Échec de l\'enregistrement de l\'utilisateur assigné. Veuillez réessayer.',
    atsCreateModalTitle: 'Créer un nouveau placement ATS',
    atsPlacementIdLabel: 'ID de placement ATS',
    atsPlacementIdPlaceholder: 'Entrer l\'ID de placement ATS',
    atsCreateButton: 'Créer',
    atsCreatingButton: 'Création en cours...',
    atsCreateDuplicate: 'L\'identifiant ATS {id} est déjà dans la file.',
    atsCreateDuplicateWorker: 'Travailleur',
    atsCreateDuplicateClient: 'Client',
    atsCreateDuplicateQuestion: 'Voulez-vous tout de même continuer ?',
    atsCreateProceed: 'Oui, continuer',
    atsCancelModalTitle: 'Annuler la demande',
    atsSourceName: 'File d\'attente ATS',
    atsPlacementNoun: 'placement',
    atsHoldActionName: 'Mettre en attente',
    // ATS Sync Settings
    atsSyncCreateNewAts: 'Créer un nouveau ATS',
    atsSyncInclusionSettingsLabel: 'Paramètres d\'inclusion de synchronisation ATS',
    atsSyncSearchLabel: 'Rechercher des clients par nom',
    atsSyncSearchPlaceholder: 'Rechercher par nom de client ou ID ATS...',
    atsSyncFilters: 'Filtres',
    atsSyncStatus: 'Statut',
    atsSyncStatusAll: 'Tous',
    atsSyncStatusEnabled: 'Activés',
    atsSyncStatusDisabled: 'Désactivés',
    atsSyncWarningsOnly: 'Avec avertissements',
    atsSyncUnmappedOnly: 'Non mappés',
    atsSyncCountry: 'Pays',
    atsSyncAny: 'Tous',
    atsSyncProvinceState: 'Province / État',
    atsSyncSelectCountryFirst: 'Sélectionner un pays d\'abord',
    atsSyncSearchCountry: 'Rechercher des pays...',
    atsSyncSearchSubdivision: 'Rechercher des provinces / États...',
    atsSyncNoResults: 'Aucun résultat',
    atsSyncCity: 'Ville',
    atsSyncNoClientsMatch: 'Aucun client ne correspond aux filtres actuels',
    atsSyncModalTitle: 'Synchronisation ATS — Paramètres d\'inclusion',
    atsSyncModalSubtitle: 'Configurez les clients et les lignes d\'affaires inclus dans la synchronisation ATS.',
    atsSyncUnmappedClientsLabel: 'Clients non mappés (par défaut)',
    atsSyncUnmappedClientsSubtitle: 'S\'applique aux placements ATS sans client FBO mappé',
    atsSyncUnmappedClientsTooltip: 'Ces règles s\'appliquent à tous les placements ATS dont le client n\'est pas mappé à une organisation FBO. Activez une ligne d\'affaires pour créer automatiquement ces placements avec un client vide; laissez cette section vide pour les ignorer.',
    atsSyncClientsEnabled: '{count} clients activés',
    atsSyncClientsShown: '{shown} sur {total} clients affichés',
    atsSyncClientsTotal: '{total} clients',
    atsSyncUnsavedChange: '· {count} modification non enregistrée',
    atsSyncUnsavedChanges: '· {count} modifications non enregistrées',
    atsSyncApplyToAll: 'Appliquer à tous ({count})',
    atsSyncSaving: 'Enregistrement...',
    atsSyncNoMappingTooltip: 'Aucun client ATS n\'est associé à ce client FBO. La synchronisation automatique ne traitera pas les placements de ce client.',
    atsSyncDuplicateSingleTooltip: 'L\'identifiant ATS {id}{name} est associé à plus d\'un client FBO. La synchronisation automatique ne peut pas déterminer quel client utiliser.',
    atsSyncDuplicateMultipleTooltip: 'Les identifiants ATS {ids} sont chacun associés à plus d\'un client FBO. La synchronisation automatique ne peut pas déterminer quel client utiliser.',
    atsSyncApplyToAllTitle: 'Appliquer à tous',
    atsSyncApplyToAllBodySingular: 'Les paramètres LOB sélectionnés seront appliqués à {count} client. Cela écrasera ses paramètres actuels.',
    atsSyncApplyToAllBodyPlural: 'Les paramètres LOB sélectionnés seront appliqués à {count} clients. Cela écrasera leurs paramètres actuels.',
    atsSyncAllClients: 'Tous les clients',
    atsSyncAllLinesOfBusiness: 'Toutes les lignes d\'affaires',
    atsSyncApplyToCount: 'Appliquer à {count}',
    // Export Modal
    exportToExcel: 'Exporter vers Excel',
    exportScope: 'Portée',
    current: 'actuel',
    rows: 'lignes',
    exportColumnsForStage: 'Colonnes pour {stage}',
    exportExcludeInternal: 'Exclure {count} colonne(s) internes seulement',
    exportShowVisibleOnly: 'Afficher seulement les colonnes visibles',
    exportShowAllColumns: 'Afficher toutes les colonnes…',
    exportNoColumns: 'Aucune colonne disponible',
    exportNotClientFacing: 'Non destiné aux clients',
    exportPrivateColumn: 'Colonne privée',
    exportWarnNotClientFacingCount: 'colonne(s) sont marquées comme non destinées aux clients',
    exportWarnNotClientFacingBody: 'Ne partagez pas ce fichier avec les clients.',
    exportWarnPrivateCount: 'colonne(s) privée(s) incluse(s)',
    exportWarnPrivateBody: 'Celles-ci sont internes seulement — excluez-les avant tout partage externe.',
    exportTooLarge: 'Exportation trop volumineuse',
    exportFilename: 'Nom du fichier',
    exportFilenameHint: '.xlsx est ajouté automatiquement si vous l\'omettez.',
    exporting: 'Exportation…',
    exportRowsButton: 'Exporter {count} lignes',
    exportUnexpectedError: 'Erreur inattendue',
    exportServerError: 'Le serveur a renvoyé {status}',
    // VMS Integration Settings
    vmsSettingsTitle: 'Paramètres d\'intégration VMS',
    vmsSkipPublicDomainFilterLabel: 'Accepter les expéditeurs de domaines publics',
    vmsSkipPublicDomainFilterNote: 'Lorsque activé, les courriels provenant de gmail / outlook / yahoo / autres fournisseurs de messagerie publics créent automatiquement une demande. Lorsque désactivé (par défaut), ils sont mis en attente à « En attente de création manuelle » pour révision. Se propage à chaque client lié à ce locataire.',
    vmsTenant: 'Locataire',
    vmsAllTypes: 'Tous les types',
    vmsActiveOnly: 'Actifs uniquement',
    vmsSearchPlaceholder: 'Rechercher par nom ou client...',
    vmsNoSettingsMatch: 'Aucun paramètre ne correspond à vos filtres.',
    vmsSelectSetting: 'Sélectionnez un paramètre ou créez-en un nouveau.',
    vmsInactive: 'Inactif',
    vmsCopyEmail: 'Copier l\'adresse courriel',
    vmsEmailsReceived: 'courriel(s) reçu(s)',
    vmsLast: 'Dernier',
    vmsFboClient: 'Client FBO',
    vmsClientReadOnly: 'Le client ne peut pas être modifié. Pour utiliser un autre client, créez un nouveau paramètre.',
    vmsDisplayName: 'Nom d\'affichage',
    vmsNotesOptional: 'Notes (facultatif)',
    vmsNotesPlaceholder: 'Notes internes...',
    vmsTypeLabel: 'Type VMS',
    vmsTypeNone: 'Aucun — détecter par courriel',
    vmsTypeNote: 'Lorsqu\'il est défini, ce type est appliqué à chaque demande créée à partir des courriels sur ce point de terminaison, remplaçant la supposition de l\'IA pour chaque courriel.',
    vmsDefaultAssignees: 'Cessionnaires par défaut',
    vmsSearchUsers: 'Rechercher des utilisateurs...',
    vmsPrimaryAssignee: 'Principal — assigné automatiquement',
    vmsPrimaryAssigneeNote: 'Le premier cessionnaire est pré-rempli sur les nouvelles demandes; les autres sont stockés pour une réaffectation rapide.',
    vmsLoadedHint: 'Affichage de {loaded} sur {total}',
    vmsLoadingMore: 'Chargement...',
    vmsMainInfo: 'Informations principales',
    vmsVersionTooltip: 'Version {n}. Chaque modification sémantique crée une nouvelle version; les modifications cosmétiques (nom d\'affichage, notes, bascule active) modifient le document existant.',
    vmsHistorySection: 'Historique',
    vmsNoAuditEntries: 'Aucune entrée d\'historique pour le moment.',
    vmsCopySuccess: 'Adresse courriel copiée dans le presse-papiers.',
    vmsCopyInactiveWarning: 'Cette configuration est inactive — les courriels envoyés à cette adresse ne seront pas associés à ce client tant qu\'elle ne sera pas réactivée.',
    vmsRowCopyEmail: 'Copier l\'adresse courriel',
    vmsDiscard: 'Annuler',
    vmsDeleteSetting: 'Supprimer le paramètre',
    vmsDeleteConfirm: 'Êtes-vous sûr de vouloir supprimer',
    vmsDeleteEmailWarning: 'L\'adresse courriel cessera de recevoir de nouveaux courriels.',
    vmsDeleting: 'Suppression...',
    vmsNewTenantSetting: 'Nouveau paramètre courriel locataire',
    vmsNewClientSetting: 'Nouveau paramètre courriel client',
    vmsTenantDescription: 'Boîte de réception VMS partagée à l\'échelle de l\'organisation pour tous les clients.',
    vmsClientDescription: 'Boîte de réception VMS liée à un client FBO spécifique.',
    vmsSearchClient: 'Rechercher par nom de client...',
    vmsChangeClient: 'Changer de client',
    vmsTenantNameExample: 'ex. Boîte VMS principale',
    vmsClientNameExample: 'ex. Boîte VMS ACME',
    vmsLlmConfig: 'Configuration LLM',
    vmsLlmConfigDescription: 'Modèle et paramètres de jetons pour l\'analyse des courriels VMS avec cette configuration. Les paramètres client héritent de la configuration locataire liée.',
    vmsDefaultLlmConfig: 'Définir comme configuration LLM par défaut pour ce locataire',
    vmsModel: 'Modèle',
    vmsMaxTokens: 'Jetons max.',
    vmsCustomPrompt: 'Instructions de prompt personnalisées (facultatif)',
    vmsCustomPromptPlaceholder: 'Instructions supplémentaires ajoutées au prompt d\'extraction par défaut. Laissez vide pour utiliser les paramètres par défaut avec les garde-fous de sécurité standard.',
    vmsPromptSafetyNote: 'La protection contre l\'injection de prompt et les garde-fous de sécurité intégrés sont toujours appliqués, indépendamment des instructions personnalisées.',
    vmsEmailDomain: 'Domaine courriel :',
    vmsEmailDomainNote: 'La modification du domaine nécessite la mise à jour de la configuration du serveur et du fournisseur de service courriel. Les adresses courriel existantes cesseront de fonctionner si le domaine est modifié.',
    vmsDiscardConfirm: 'Vous avez des modifications non enregistrées. Voulez-vous les annuler et continuer ?',
    vmsGoBack: 'Retour',
    vmsDiscardContinue: 'Annuler et continuer',
    // Added: previously-missing keys
    allowDataExport: 'Autoriser l\'exportation des données',
    alsoSaveChangesOn: 'Autres onglets avec des modifications non enregistrées',
    alsoSaveChangesOnHelp: 'L\'enregistrement appliquera aussi les modifications faites sur ces onglets. Décochez ceux que vous voulez laisser en brouillon.',
    applyChanges: 'Appliquer les modifications',
    atsSyncSettings: 'Paramètres de synchronisation ATS',
    bulkEditDescription: 'Mise à jour de {count} élément(s) sélectionné(s)',
    bulkUpdateError: 'Échec de la mise à jour en masse',
    bulkUpdateErrorDesc: 'Une erreur s\'est produite lors de la mise à jour en masse.',
    bulkUpdateFailed: 'Échec de la mise à jour de {count} enregistrement(s){details}',
    bulkUpdatePartial: 'Mise à jour réussie de {success} enregistrement(s). {failed} enregistrement(s) en échec{details}',
    bulkUpdateSuccess: 'Mise à jour réussie de {count} enregistrement(s).',
    done: 'Terminé',
    export: 'Exporter',
    field: 'Champ',
    hours: 'Heures',
    minutes: 'Minutes',
    noFieldsSelected: 'Aucun champ sélectionné',
    originalEmail: 'Courriel d\'origine',
    pleaseSelectAtLeastOneField: 'Veuillez sélectionner au moins un champ.',
    removeField: 'Retirer le champ',
    selectEndDate: 'Sélectionner la date de fin...',
    selectField: 'Sélectionner un champ...',
    selectFieldFirst: 'Sélectionnez d\'abord un champ',
    selectStartDate: 'Sélectionner la date de début...',
    time: 'Heure',
    updatesView: 'met à jour',
    value: 'Valeur',
    viewAllowDataExportEnabled: 'L\'exportation des données est activée pour cette vue',
    vmAllowDataExportHelp: 'Lorsque activé, les utilisateurs ayant la permission d\'exportation peuvent exporter cette vue vers Excel.',
    vmExportDisabled: 'Exportation désactivée',
    vmExportEnabled: 'Exportation activée',
    vmRevert: 'Rétablir les modifications',
    // Messages inbox filters
    inboxSearchPlaceholder: 'Rechercher par nom du travailleur, n° de bon de travail, ID ATS ou ID VMS',
    inboxFilters: 'Filtres',
    inboxFilterDate: 'Date du dernier message',
    inboxFilterFrom: 'Du',
    inboxFilterTo: 'Au',
    inboxFilterWorkOrderStages: 'Étapes du bon de travail',
    inboxFilterRequests: 'Demandes',
    inboxFilterSender: 'Expéditeur',
    inboxFilterAny: 'Tous',
    inboxFilterSelectedCount: '{count} sélectionné(s)',
    inboxNoMatches: 'Aucun message ne correspond à vos filtres.',
  },
};